<template>
	<div>
		<!--  @touchstart='touchstart' @touchmove='touchmove' @touchend="touchend"   @click="setRead($event)"-->
		<div class="book" ref="wrapper" id="reader-page-view" @touchstart.prevent.stop='touchstart'
			@touchend.prevent.stop="touchend" :style="{background:background,color:fontColor}">
			<div v-if="pagingPattern===0" class="books-con" v-infinite-scroll="loadMore"
				infinite-scroll-disabled="loading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
				<div class="book-content" ref="content" v-for="(item,idx) in bookContent" v-if="fileList == ''">
					<h1 class="book-title" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}">
						{{'第' + item.number + '章' + '&nbsp;&nbsp;' + item.title}}</h1>
					<!-- <div class="book-inner" ref="contentBox" v-html="bookChaptersBody(item.content)" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}"></div> -->
					<div v-for="(itemContent,indexContent) in item.contentList" :id="indexContent">
						<div style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;">{{itemContent.replace(/&nbsp;/g, '').replace(/\s/g, "")}}</div>
						<div style="width: 100%;height: 20px;"></div>
					</div>
					<!-- <pre class="book-inner" ref="contentBox" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}" v-html="item.content"></pre> -->
				</div>

				<div class="book-content" ref="content" v-for="(item,idx) in bookContent" v-if="fileList != ''">
					<h1 class="book-title" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}">
						{{item.title}}</h1>
					<div v-for="(itemContent,indexContent) in item.contentList" :id="indexContent">
						<div style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;">{{itemContent.replace(/&nbsp;/g, '').replace(/\s/g, "")}}</div>
						<div style="width: 100%;height: 20px;"></div>
					</div>
					<!-- <pre class="book-inner" ref="contentBox" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}" v-html="item.content"></pre> -->
					<!-- <div class="book-inner" v-html="bookChaptersBody(fileTxt)" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}"></div> -->
				</div>


				<div class="loadMore" style="text-align: center" v-show="moreLoading">
					<van-loading type="spinner" color="#409eff" />
				</div>
			</div>

			<div class="read-content" v-if="pagingPattern===1" v-for="(item,idx) in bookContent">
				<div class="book-title01" style="clear: both;">
					<div>
						<span>{{item.books_name}}</span>
					</div>
					<div>
						<span>第{{item.number}}章</span>
						<span>{{item.title}}</span>
					</div>

				</div>
				<div class="read-article">
					<section class="read-section" v-if="fileList == ''" :style="styleObject">
						<div class="read-section-inner" :style="{columns:clWidth-20+'px',columnGap:10+'px'}"
							ref="bookInner" id="bookInner">
							<h1 class="book-title" :style="{fontSize:fontSize+'px',color:fontColor}">
								{{'第' + item.number + '章' + '&nbsp;&nbsp;' + item.title}}</h1>
							<!-- <div class="book-inner book-innerTopTxt" v-if="item.location_status == 1 && item.narrate != ''" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}"
							 ref="audiovalue" v-html="bookChaptersBody( `<c>作者留言：</c>` + item.narrate + '<p></p>\n' + item.content )"></div> -->
							<div class="book-inner book-innerTopTxt"
								v-if="item.location_status == 1 && item.narrate != ''"
								:style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}"
								ref="audiovalue">
								<c>作者留言：</c>
								<pre :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}" v-html="item.narrate"></pre>
								<br />
								<div v-for="(itemContent,indexContent) in item.contentList" :id="indexContent">
									<div style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;">{{itemContent.replace(/&nbsp;/g, '').replace(/\s/g, "")}}</div>
									<div style="width: 100%;height: 20px;"></div>
								</div>
							</div>
							<!-- <div class="book-inner" v-if="item.location_status == 2 && item.narrate != ''" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}"
							 ref="audiovalue" v-html="bookChaptersBody(item.content + `<i>作者留言：</i>`+ item.narrate)"></div> -->
							<div class="book-inner" v-if="item.location_status == 2 && item.narrate != ''" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}" ref="audiovalue">
								<div v-for="(itemContent,indexContent) in item.contentList" :id="indexContent">
									<div style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;">{{itemContent.replace(/&nbsp;/g, '').replace(/\s/g, "")}}</div>
									<div style="width: 100%;height: 20px;"></div>
								</div>
							 <!-- <pre :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}" v-html="item.content"></pre> -->
							<br />
							<i>作者留言:</i>
							<pre :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}"
								v-html="item.narrate.replaceAll('<p>',`<div style='width: 100%; height: 20px;'></div><p>`)"></pre>
							</div>
							<!-- <div class="book-inner" v-else :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}" ref="audiovalue"
							 v-html="bookChaptersBody(item.content)"></div> -->
							<div class="book-inner book-test-mark" v-else :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}" ref="audiovalue">
								<div v-for="(itemContent,indexContent) in item.contentList" :id="indexContent" >
									<div style="font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;">{{itemContent.replace(/&nbsp;/g, '').replace(/\s/g, "")}}</div>
									<div style="width: 100%;height: 20px;"></div>
								</div>
							<!-- <pre v-html="item.content" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px',color:fontColor}"></pre> -->
							</div>
						</div>
					</section>
					<section v-if="fileList != ''" class="books-con" v-infinite-scroll="loadMore"
						infinite-scroll-disabled="loading" infinite-scroll-distance="0"
						infinite-scroll-immediate-check="false">
						<div class="read-section-inner" :style="{columns:clWidth-20+'px',columnGap:10+'px'}"
							ref="bookInner" id="bookInner">
							<h1 class="book-title" :style="{fontSize:fontSize*1.2+'px'}">{{item.title}}</h1>
							<!-- <div class="book-inner" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}" ref="audiovalue" v-html="bookChaptersBody(fileTxt)"></div> -->
							<pre class="book-inner" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}"
								ref="audiovalue">{{fileTxt}}</pre>
						</div>
					</section>

				</div>
				<!-- <p class="article-page" style="color: red">{{currentPaging + '/' + resultPaging + "-------"}}</p> -->
				<p class="article-page" :style="{color:fontColor}" v-if="resultPaging <= 100">
					{{Math.floor(100 / resultPaging) * currentPaging}}%</p>
				<p class="article-page" :style="{color:fontColor}" v-if="resultPaging>100">
					{{Math.ceil(100 / resultPaging) * currentPaging}}%</p>
			</div>
			<!-- <div class="read-content" v-if="fileList != '' &&  pagingPattern===1" v-for="(item,idx) in bookContent">
				<div class="book-title01" style="clear: both;">
					<div>
						<span>{{item.name}}</span>
					</div>
				</div>
				<div class="read-article">
					<section class="read-section" :style="styleObject">
						<div class="read-section-inner" :style="{columns:clWidth-20+'px',columnGap:10+'px'}" ref="bookInner" id="bookInner">
							<div class="book-inner" :style="{fontSize:fontSize+'px',lineHeight:lineHeight+'px'}" ref="audiovalue" v-html="bookChaptersBody(item.content)"></div>
						</div>
					</section>
				</div>
				<p class="article-page" :style="{color:fontColor}">{{"-------" + currentPaging + '/' + resultPaging}}</p>
				<p class="article-page" :style="{color:fontColor}">{{Math.floor(100 / resultPaging) * currentPaging}}%</p>
			</div> -->
			<!-- vip订阅 -->
		</div>
		<vipread v-show="readBookShow == false" :vipBooks_name="vipBooks_name" :vipNumber="vipNumber"
			:vipTitle="vipTitle" :vip_cost="vip_cost" :vipUser_money="vipUser_money" :btn_list_val="btn_list_val"
			:tabSubscribechapter="tabSubscribechapter"
			@subscribeChapter="subscribechapter" ></vipread>
		<div class="page-read-option" :class="{'show-panel':option}" @click="setReadShow">
			<div class="top-controll-bar">
				<div class="headerBox" v-if="isLlock == true">
					<div class="headerQuery">
						<div class="arrImg" @click.stop="back">
							<img src="../../assets/img/myicon/left01.png" alt="">
						</div>
						<div class="header_titile">
							<img src="../../assets/img/myicon/singsong.png" alt="" @click.stop="setmusice" />
							<img src="../../assets/img/myicon/read01.png" alt="" @click.stop="audiovalueFnPause"/>
							<!-- 书签 -->
							<img src="../../assets/img/myicon/sq.png" alt=""
								v-if="readInfoData.type == null || chapterType == 201"
								@click.stop="collect_chapterFn" />
							<img src="../../assets/img/myicon/sq_acitve.png" alt=""
								v-if="readInfoData.type == 2 || chapterType == 200" @click.stop="collect_chapterFn" />
							<img src="../../assets/img/myicon/ellicon.png" alt="" />
						</div>
					</div>
				</div>
				<div class="headerBox" :style="{height: 50 +'px'}" v-if="isLlock == false">
					<div class="headerQuery" :style="{marginTop: 0 +'px'}">
						<div class="arrImg" @click.stop="back">
							<img src="../../assets/img/myicon/left01.png" alt="">
						</div>
						<div class="header_titile">
							<img src="../../assets/img/myicon/singsong.png" alt="" @click.stop.pervent="setmusice" />
							<img src="../../assets/img/myicon/read01.png" alt="" />
							<img src="../../assets/img/myicon/sq.png" alt=""
								v-if="readInfoData.type == null || chapterType == 201"
								@click.stop="collect_chapterFn" />
							<img src="../../assets/img/myicon/sq_acitve.png" alt=""
								v-if="readInfoData.type == 2 ||  chapterType == 200" @click.stop="collect_chapterFn" />
							<img src="../../assets/img/myicon/ellicon.png" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="bgcSet">
				<div v-if="show == true" @click.stop="bgcSon">
					<img src="../../assets/img/myicon/son.png" class="son" alt="">
				</div>
				<div v-if="show == false" @click.stop="bgcNight">
					<img src="../../assets/img/myicon/night.png" class="night" alt="">
				</div>
			</div>
			<div class="bottom-controll-bar" v-if="isLlock == true">
				<div class="footer_fixedBox">
					<div class="footer_setBox">
						<div class="footer_topBox">
							<div class="sliderBox">
								<van-slider v-model="slidervalue" :step="stepSet" @change="onChange" disabled
									active-color="#ff4081" />
							</div>
							<!--   -->
							<img src="../../assets/img/myicon/left01.png" alt="" @click.stop="left_arr"
								class="leftArr" />
							<img src="../../assets/img/myicon/left01.png" alt="" @click.stop="right_arr"
								class="rightArr" />
						</div>
						<p class="slidervalue" v-if="slidervalue == 'NaN' ? false : true">{{slidervalue}}%</p>
						<div class="navBarBtn">
							<!-- @click="catalogFn" -->
							<div @click.stop="setList">
								<img src="../../assets/img/myicon/ml.png" alt="">
								<p>目录</p>
							</div>
							<div @click.stop="set">
								<img src="../../assets/img/myicon/set01.png" alt="">
								<p>设置</p>
							</div>
							<div @click.stop='toComment'>
								<img src="../../assets/img/myicon/pl.png" alt="">
								<p>评论</p>
							</div>
							<div @click.stop="givegifts">
								<img src="../../assets/img/myicon/lw.png" alt="">
								<p>送礼物</p>
							</div>
							<div @click.stop="pldyFn">
								<img src="../../assets/img/myicon/gm.png" alt="">
								<p>购买</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 背景颜色设置 -->
		<div class="font_color_fatherBox" v-show="bgc_set_show" @click.stop="set">
			<div class="font_color_box">
				<div class="bgc_ld">
					<div class="sliderBox">
						<van-slider active-color="#ff4081" v-model="range" @change="setBrightnessFn" :min="0" :max="1"
							:step="0.1" />
					</div>
					<span @click.stop="xtFontFn">系统字体</span>
				</div>
				<div class="bgc_seleBox">
					<div class="bgc_seleBox_child">
						<span v-for="(item,index) in pattern">
							<span :class="{active:readePattern===index}" @click.stop="setPattern(item,index)"
								:style="{backgroundColor: item.background}"></span>
						</span>
					</div>
				</div>
				<div class="set_font">
					<div class="fontsize_min">
						<span @click.stop="fontSet('reduce',$event)">-</span>
						<span>字号</span>
						<span @click.stop="fontSet('add',$event)">+</span>

					</div>
					<div class="fontsize_min">
						<span @click.stop="lineHeightSet('reduce',$event)">-</span>
						<span>行距</span>
						<span @click.stop="lineHeightSet('add',$event)">+</span>
					</div>
					<div class="fontsize_min">
						<span @click.stop="paddingSet('reduce',$event)">-</span>
						<span>边距</span>
						<span @click.stop="paddingSet('add',$event)">+</span>
					</div>
				</div>
				<div class="moreSet_box">
					<div @click="lockOrients()" v-if="isLlock">
						<img src="../../assets/img/myicon/hp_icon.png" alt="">
						<p>横屏</p>
					</div>
					<div @click="unlockOrients()" v-else>
						<img src="../../assets/img/myicon/hp_icon.png" alt="">
						<p>竖屏</p>
					</div>
					<!-- 简体 -->
					<div @click.stop="onSwitchLanguage('s')" v-if="isTraditional">
						<img src="../../assets/img/myicon/jf_font.png" alt="">
						<p>简繁体</p>
					</div>
					<!-- 繁体 -->
					<div @click.stop="onSwitchLanguage('t')" v-else>
						<img src="../../assets/img/myicon/jf_font.png" alt="">
						<p>简繁体</p>
					</div>
					<div @click.stop="moresetPage">
						<img src="../../assets/img/myicon/set_add.png" alt="">
						<p>更多</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="fileList == ''">
			<!-- 目录弹窗 -->
			<div class="mlBox" v-show="listOption" @click.stop="setList">
				<div class="ml_infoBox">
					<div class="ml_top navBar">
						<div class="ml_tab navBarBox">
							<div class="tab_item" v-for="(item,index) in navbar" :key="index"
								:class="navBarIndex == index ? 'active' : ''" @click.stop="navbarFn(index)">
								<span>{{item}}</span>
								<p></p>
							</div>
							<div class="ml_solt" @click.stop="soltFn">
								<img src="../../assets/img/ml_solt.png" alt="" />
							</div>
						</div>
					</div>
					<div v-if="navBarIndex == 0 ? true : false">
						<div class="ml_body" v-if="book_details.chapter_list">
							<!-- 免费 active-->
							<div v-for="(item,index) in book_details.chapter_list"
								v-if="book_details.chapter_list.length　<=　10 ? true : false">
								<div>
									<!-- 卷标 -->
									<div class="jbm" v-if="item.volume_label != null && !solt_reverse">
										{{item.volume_label}}</div>
									<!-- vip章节 -->
									<div class="mlListItem" :class="item.id == (chapter_id || dqpage) ? 'active' : ''"
										@click.stop="jumpReadbook(item.id,item.books_id,item.lock_status,item.lock_id,item.is_vip,item.number)">
										<div class="mlListItem_left">
											<p><span class="num">{{item.number}}</span>
												<span class="bookName">
													<van-notice-bar :scrollable="scrollable" :text="item.title.trim()"
														speed='20' delay='2'></van-notice-bar>
												</span>
												<img v-if="item.lock_status == 0 ? true : false"
													src="../../assets/img/ml_activeJs.png" alt="" />
												<img v-if="item.lock_status == 2 ? true : false"
													src="../../assets/img/ml_wjs.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 0 ? true : false"
													src="../../assets/img/bjvipicon.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 1 ? true : false"
													src="../../assets/img/vipicon.png" alt="">
											</p>
											<p v-if="item.is_vip != 0 && item.is_vip != 1 ? true : false">
												{{item.views_num}}点击</p>
										</div>
										<div class="mlListItem_middle">
											<p><span><span v-for="(itm,idx) in item.synopsis.trim()"
														v-if="idx<=11">{{itm}}</span></span></p>
											<p><span>{{formatDateTime(item.updatetime)}}</span></p>
										</div>
										<div class="mlListItem_right">
											<p>{{item.words_num}}字</p>
										</div>
									</div>
									<div class="jbm" v-if="item.volume_label != null && solt_reverse">
										{{item.volume_label}}</div>
								</div>

							</div>
							<div v-for="(item,index) in book_details.chapter_list"
								v-if="index <= 4 &&　book_details.chapter_list.length　>　10 ? true : false">
								<div>
									<!-- 卷标 -->
									<div class="jbm" v-if="item.volume_label != null && !solt_reverse">
										{{item.volume_label}}</div>
									<!-- vip章节 -->
									<div class="mlListItem" :class="item.id == (chapter_id || dqpage) ? 'active' : ''"
										@click.stop="jumpReadbook(item.id,item.books_id,item.lock_status,item.lock_id,item.is_vip,item.number)">
										<div class="mlListItem_left">
											<p><span class="num">{{item.number}}</span>
												<!-- <span class="bookName"><span v-for="(item,idx) in item.title.trim()"
													 v-if="idx > 3 ? false : true">{{item}}</span></span> -->
												<span class="bookName">
													<van-notice-bar :scrollable="scrollable" :text="item.title.trim()"
														speed='20' delay='2'></van-notice-bar>
												</span>
												<!-- lock_id == 1 管理员 lock_status 锁定状态-->
												<img v-if="item.lock_status == 0 ? true : false"
													src="../../assets/img/ml_activeJs.png" alt="" />
												<img v-if="item.lock_status == 2 ? true : false"
													src="../../assets/img/ml_wjs.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 0 ? true : false"
													src="../../assets/img/bjvipicon.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 1 ? true : false"
													src="../../assets/img/vipicon.png" alt="">
											</p>
											<p v-if="item.is_vip != 0 && item.is_vip != 1 ? true : false">
												{{item.views_num}}点击</p>
										</div>
										<div class="mlListItem_middle">
											<p><span><span v-for="(itm,idx) in item.synopsis.trim()"
														v-if="idx<=11">{{itm}}</span></span></p>
											<p><span>{{formatDateTime(item.updatetime)}}</span></p>
										</div>
										<div class="mlListItem_right">
											<p>{{item.words_num}}字</p>
										</div>
									</div>
									<div class="jbm" v-if="item.volume_label != null && solt_reverse">
										{{item.volume_label}}</div>
								</div>

							</div>
							<div class="lookall" @click.stop="allMFzjFn"
								v-if="!allMFzj && book_details.chapter_list.length　>　10">查看全部&gt;&gt;&gt;&gt;</div>
							<div v-for="(item,index) in book_details.chapter_list"
								v-if="index < book_details.chapter_list.length - 5 &&  index >= 5 &&　book_details.chapter_list.length　>　10 && allMFzj == true ? true : false">
								<div>
									<!-- 卷标 -->
									<div class="jbm" v-if="item.volume_label != null && !solt_reverse">
										{{item.volume_label}}</div>
									<!-- vip章节 -->
									<div class="mlListItem" :class="item.id == (chapter_id || dqpage) ? 'active' : ''"
										@click.stop="jumpReadbook(item.id,item.books_id,item.lock_status,item.lock_id,item.is_vip,item.number)">
										<div class="mlListItem_left">
											<p><span class="num">{{item.number}}</span>
												<!-- <span class="bookName"><span v-for="(item,idx) in item.title.trim()"
													 v-if="idx > 3 ? false : true">{{item}}</span></span> -->
												<span class="bookName">
													<van-notice-bar :scrollable="scrollable" :text="item.title.trim()"
														speed='20' delay='2'></van-notice-bar>
												</span>
												<!-- lock_id == 1 管理员 lock_status 锁定状态-->
												<img v-if="item.lock_status == 0 ? true : false"
													src="../../assets/img/ml_activeJs.png" alt="" />
												<img v-if="item.lock_status == 2 ? true : false"
													src="../../assets/img/ml_wjs.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 0 ? true : false"
													src="../../assets/img/bjvipicon.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 1 ? true : false"
													src="../../assets/img/vipicon.png" alt="">
											</p>
											<p v-if="item.is_vip != 0 && item.is_vip != 1 ? true : false">
												{{item.views_num}}点击</p>
										</div>
										<div class="mlListItem_middle">
											<p><span><span v-for="(itm,idx) in item.synopsis.trim()"
														v-if="idx<=11">{{itm}}</span></span></p>
											<p><span>{{formatDateTime(item.updatetime)}}</span></p>
										</div>
										<div class="mlListItem_right">
											<p>{{item.words_num}}字</p>
										</div>
									</div>
									<div class="jbm" v-if="item.volume_label != null && solt_reverse">
										{{item.volume_label}}</div>
								</div>
							</div>
							<div v-for="(item,index) in book_details.chapter_list"
								v-if="index >= book_details.chapter_list.length - 5 &&　book_details.chapter_list.length　>　10　? true : false">
								<div>
									<!-- 卷标 -->
									<div class="jbm" v-if="item.volume_label != null && !solt_reverse">
										{{item.volume_label}}</div>
									<!-- vip章节 -->
									<div class="mlListItem" :class="item.id == (chapter_id || dqpage) ? 'active' : ''"
										@click.stop="jumpReadbook(item.id,item.books_id,item.lock_status,item.lock_id,item.is_vip,item.number)">
										<div class="mlListItem_left">
											<p><span class="num">{{item.number}}</span>
												<span class="bookName">
													<van-notice-bar :scrollable="scrollable" :text="item.title.trim()"
														speed='20' delay='2'></van-notice-bar>
												</span>
												<!-- <span class="bookName"><span v-for="(item,idx) in item.title.trim()"
													 v-if="idx > 3 ? false : true">{{item}}</span></span> -->
												<!-- lock_id == 1 管理员 lock_status 锁定状态-->
												<img v-if="item.lock_status == 0 ? true : false"
													src="../../assets/img/ml_activeJs.png" alt="" />
												<img v-if="item.lock_status == 2 ? true : false"
													src="../../assets/img/ml_wjs.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 0 ? true : false"
													src="../../assets/img/bjvipicon.png" alt="">
												<img class="vip_lock" v-if="item.is_vip == 1 ? true : false"
													src="../../assets/img/vipicon.png" alt="">
											</p>
											<p v-if="item.is_vip != 0 && item.is_vip != 1 ? true : false">
												{{item.views_num}}点击</p>
										</div>
										<div class="mlListItem_middle">
											<p><span><span v-for="(itm,idx) in item.synopsis.trim()"
														v-if="idx<=11">{{itm}}</span></span></p>
											<p><span>{{formatDateTime(item.updatetime)}}</span></p>
										</div>
										<div class="mlListItem_right">
											<p>{{item.words_num}}字</p>
										</div>
									</div>
									<div class="jbm" v-if="item.volume_label != null && solt_reverse">
										{{item.volume_label}}</div>
								</div>
							</div>
						</div>

						<div class="bookInfoBtn" @click.stop="mltostShow">
							<button>书本详情</button>
						</div>
					</div>
					<div v-if="navBarIndex == 1 ? true : false">
						<div class="ml_body" v-if="book_details.bookmark_list">
							<div v-for="(item,index) in book_details.bookmark_list"
								@click.stop="jumpReadbook(item.collect_id,item.books_id,item.lock_status,item.lock_id,item.is_vip,item.number)"
								@touchstart="showDeleteButtonFn(item.id)" @touchend="emptyTime"
								v-if="book_details.bookmark_list.length != 0">
								<div>
									<div class="mlListItem">
										<div class="mlListItem_left">
											<p><span class="num">{{item.number}}</span>
												<span class="bookName">
													<van-notice-bar :scrollable="scrollable" :text="item.title.trim()"
														speed='20' delay='2'></van-notice-bar>
												</span>
											</p>
											<p v-if="item.is_vip != 0 && item.is_vip != 1 ? true : false">
												{{item.views_num}}点击</p>
										</div>
										<div class="mlListItem_middle">
											<p><span><span v-for="(itm,idx) in item.synopsis.trim()"
														v-if="idx<=11">{{itm}}</span></span></p>
											<p><span>{{formatDateTime(item.createtime)}}</span></p>
										</div>
										<div class="mlListItem_right">
											<p>{{item.words_num}}字</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="book_details.bookmark_list.length == 0">
								<p style="text-align: center;padding-top:100px;">暂无收藏</p>
							</div>
						</div>
					</div>
				</div>
				<div class="mask" @click.stop="mltostHideFn"></div>
			</div>

			<!-- 自动播放 -->
			<!-- 音乐toast -->
			<div class="toast_father_setBox" v-show="musice_box" @click.stop="setmusice">
				<div class="toast_setBox">
					<div class="toast_top_setBox">
						<div class="ml_box">
							<img src="../../assets/img/myicon/ml.png" alt="">
							<p>目录</p>
						</div>
						<div class="singsong_set">
							<img src="../../assets/img/myicon/kj01.png" alt="">
							<img src="../../assets/img/myicon/read02.png" alt="" @click.stop="audiovalueFnPause">
							<img src="../../assets/img/myicon/kj02.png" alt="">
						</div>
						<div class="time_box">
							<img src="../../assets/img/myicon/tiem.png" alt="" />
							<p>定时</p>
						</div>
					</div>
					<p>朗读设置</p>
					<div class="footer_topBox">
						<div class="sliderBox">
							<!-- v-model="readvalue" @change="readChange" -->
							<van-slider active-color="#ff4081" :step="0.1" v-model="speed" @change="changeSpeed" :min="0.5" :max="2" />
						</div>
						<span @click.stop="slow_btnFn" class="slow">慢</span>
						<span @click.stop="fast_btnFn" class="fast">快</span>
					</div>
					{{speed}}
					<p>朗读模式</p>
					<div class="readingMode">
						<button @click.stop="audiovalueFnPause(0)">女声朗读</button>
						<button >男声朗读</button>
					</div>
					<div class="quitReading" @click.stop="stopFn">
						<div class="quitReading_left">
							<img src="../../assets/img/myicon/close.png" alt="">
						</div>
						<div class="quitReading_right">
							<p>退出朗读</p>
						</div>
					</div>
				</div>
			</div>

			<van-popup v-model="showSc">
				<div class="scBox">
					<p>喜欢本书就收藏吧</p>
					<van-radio-group v-model="scRadio" checked-color="#ff4081">
						<!-- @click="scRadioFn" -->
						<van-radio name="1">下次不再提醒</van-radio>
					</van-radio-group>
					<div class="btn_box">
						<span v-for="(btnItem,btnIndex) in btn_list" :key="btnIndex" @click.stop="scbtnFn(btnIndex)"
							:class="scindex == btnIndex ? 'active' : ''">{{btnItem}}</span>
					</div>
				</div>
			</van-popup>

		</div>

		<!-- 电量条 -->
		<div class="fixedBox">
			<div class="inner">
				<div class="battery">
					<div class="power" :style="{width: percent + 'px'}"></div>
				</div>
			</div>
			<span :style="{color:fontColor}">{{dateTime}}</span>
		</div>
		<!-- 弹窗 -->
		<div class="tostBoxFather" v-show="tostShowBox == true">
			<div class="header_img">
				<img src="../../assets/img/pltost.png" alt="" />
			</div>
			<!-- <div class="dog_img">
					<img src="../../assets/img/dog.png" alt="" />
				</div> -->
			<div class="tostBoxson">
				<div class="yunjinbiBox">
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''"
						v-for="(item, index) in yunjinbiList" :key="index"
						@click="itemyunjinbiFn(index,item.txt,item.num)">
						<div class="yunjinbi_left">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="yunjinbi_right">
							<span>{{item.txt}}</span></br>
							<span v-if='item.num ==0'>{{item.jinbi}}</span>
							<span v-if='item.jinbi ==null'>{{item.num}}</span>
						</div>
					</div>
				</div>
				<div class="selecttost">
					<div>
						<span class="userInfoUsername">
							<van-field v-model="userInfoUsername" placeholder="昵称修改" input-align="left" /></span>
						<span class="autherName" @click.stop="go_fairies()">打赏排行榜</span>
						<span @click.stop="toggle" class="seleValue">
							<i v-model="queryTitle">{{queryTitle}}分</i>
							<img src="../../assets/img/downarr.png" alt="">
						</span>
					</div>
					<ul v-show="selectItem" class="select_item">
						<li v-for="(item,index) in selectItemList" @click.stop="query_select(index,item.txt)"
							:class="queryIndex == index ? 'activeQuery' : ''">
							<span>{{item.txt}}分</span>
							<span class="queryArr" v-if="queryIndex == index ? true : false"><img
									src="../../assets/img/query.png" alt=""></span>
						</li>
					</ul>
				</div>
				<div class="tost_say">
					<!-- <textarea type="text" ref="getValue" placeholder="说点啥..." v-model="ds_value" style="resize: none;"></textarea> -->
					<van-field v-model="ds_value" rows="1" autosize type="textarea" placeholder="说点啥..." />
					<!-- <img src="../../assets/img/smile.png" alt="" class="smileImg" /> -->
				</div>
				<div class="submitBox">
					<img src="../../assets/img/flower.png" alt="" class="flower">
					<button @click.stop="add_comment">确认打赏</button>
				</div>
			</div>
		</div>
		<div class="mask_ds" @click.stop="onMask" v-show="tostShowBox == true"></div>
	</div>
</template>
<script type="text/ecmascript-6">
	import {
		mapGetters
	} from 'vuex'
	import {
		Indicator,
		Toast,
		Dialog
	} from 'vant'
	import Book from '../../assets/js/bookSource';
	import qs from 'qs';
	import vipread from './vipread.vue';
	export default {
		name: 'readbookVue',
		components: {
			vipread
		},
		data() {
			return {
				text: "蒲氏集团再次标中国家航天、能源数十项项目，这一季度财经网预估，蒲氏已创下蒲氏集团有史以来最高净利润，下一条新闻，池氏集团变更执行总裁，董事局票决下一任总裁为前致远科技总裁池肃……”\\n\\n　　  财经频道演播大厅，身着整齐制服的主播轮番报道最近华国的几大国家项目，以及背后的经济动向，演播厅外，一众制作与监制抱肩暗自啧啧，虽然蒲氏本就在华国经济领域不可小觑，但随着经济转型，蒲氏集团利润有明显下滑，然而就在从大山里出来的平民总裁黎锦时上任以后，不但巩固了蒲氏在华国第一大财团的霸主地位，甚至拓宽经营范围，短短五年年内，强势占据了科技、新能源新材料等领域。\\n\\n　　“这是黎锦时上任蒲氏总裁后第七次打破蒲氏净利润峰值了吧，真是块天生会赚钱的料子，长得又好，能力有强，我要是在这位总裁没有成名前慧眼识人，抢先嫁给她就好了，嫉妒。”\\n\\n　　“有什么啊，都是吹嘘出来的，这黎锦时还不就是凤凰女而已，要不是娶了蒲氏的大公子，她也不过是个穷山沟出来的打工女而已。”\\n\\n　　“我看你是嫉妒吧，我听说这位黎总没加入蒲氏前就有自己创业做董事了，要是不是蒲氏收购，说不定现在占据新领域夺得第一财团名号的是谁呢",
				speed: 1,
				chapterType: '',
				dateTime: '', //当前时间
				percent: 0, //当前电量
				navBarIndex: 0,
				navbar: ['目录', '书签'],
				showSc: false, //收藏
				scRadio: '',
				btn_list: [
					"算了吧~",
					"加入收藏"
				],
				scindex: 1,
				slidervalue: 0, //设置 获取上一张下一张 进度
				range: 0.5,
				lineHeight: 41,
				bookContent: [],
				bookCacheContent: [],//朗读使用的临时数据
				
				BookContentDataList: [],//一篇文章每一段内容根据换行符号 
				nextContent: [],
				prevContent: [],
				bookCurrentPage: 0,
				bookSourceLinks: [],
				loading: false,
				option: false,
				chapterList: [],
				BookSourcesId: 0,
				listOption: false,
				moreLoading: false,
				changerSource: false,
				SourceList: [],
				sourceBtn: false,
				flag: false,
				bookInfo: {},
				pattern: [{
						item: '1',
						color: 'rgb(0,0,0)',
						background: '#E3EDCD'
					}, {
						item: '2',
						color: 'rgb(0,0,0)',
						background: '#f8c686'
					}, {
						item: '3',
						color: 'rgb(0,0,0)',
						background: '#93cfbf'
					}, {
						item: '4',
						color: 'rgb(0,0,0)',
						background: '#808bc8'
					}, {
						item: '5',
						color: 'rgb(0,0,0)',
						background: '#cae2a5'
					}, {
						item: '6',
						color: 'rgb(0,0,0)',
						background: '#faa8bf'
					}, {
						item: '7',
						color: 'rgb(255,255,255)',
						background: '#3f473c'
					}, {
						item: '8',
						color: 'rgb(255,255,255)',
						background: '#2a2722'
					}, {
						item: '9',
						color: 'rgb(255,255,255)',
						background: '#22312c'
					}, {
						item: '10',
						color: 'rgb(255,255,255)',
						background: '#17232f'
					},
					{
						item: '11',
						color: 'rgb(255,255,255)',
						background: '#453d3b'
					}, {
						item: '12',
						color: 'rgb(255,255,255)',
						background: 'rgba(238,169,169,1)'
					}, {
						item: '13',
						color: 'rgb(255,255,255)',
						background: 'rgba(169,99,96,1)'
					}, {
						item: '14',
						color: 'rgb(255,255,255)',
						background: 'rgba(149,74,69,1)'
					}, {
						item: '15',
						color: '#ffffff',
						background: 'rgba(220,159,180,1)'
					}, {
						item: '16',
						color: 'rgb(255,255,255)',
						background: 'rgba(202,173,95)'
					}, {
						item: '17',
						color: 'rgb(255,255,255)',
						background: 'rgba(218,201,166,1)'
					}, {
						item: '18',
						color: 'rgb(255,255,255)',
						background: 'rgba(180,165,130,1)'
					}, {
						item: '19',
						color: 'rgb(255,255,255)',
						background: 'rgba(176,119,54,1)'
					}, {
						item: '20',
						color: 'rgb(255,255,255)',
						background: 'rgba(125,108,70,1)'
					},
					{
						item: '21',
						color: 'rgb(255,255,255)',
						background: 'rgba(145,180,147,1) '
					},
					{
						item: '22',
						color: 'rgb(255,255,255)',
						background: 'rgba(93,172,129,1)'
					},
					{
						item: '23',
						color: 'rgb(255,255,255)',
						background: 'rgba(105,176,172,1)'
					},
					{
						item: '24',
						color: 'rgb(255,255,255)',
						background: 'rgba(165,222,228,1)'
					},
					{
						item: '25',
						color: 'rgb(255,255,255)',
						background: 'rgba(102,153,161,1)'
					},
					{
						item: '26',
						color: 'rgb(255,255,255)',
						background: 'rgba(87,124,138,1)'
					},
					{
						item: '27',
						color: 'rgb(255,255,255)',
						background: 'rgba(212,242,232,1)'
					},
					{
						item: '28',
						color: 'rgb(255,255,255)',
						background: 'rgba(118,102,77,1)'
					},
					{
						item: '29',
						color: 'rgb(255,255,255)',
						background: 'rgba(65,80,101,1)'
					}, {
						item: '30',
						color: 'rgb(255,255,255)',
						background: 'rgba(215,236,241,1)'
					}, {
						item: '31',
						color: 'rgb(255,255,255)',
						background: 'rgba(239,222,176,1)'
					}
				],
				offsetX: 0,
				margin: 10,
				currentPaging: 1,
				resultPaging: 1,
				prevResultPaging: 1,
				styleObject: '',
				isClickPage: false,
				fontSize: 24,
				// fontColor: '#ffffff',
				// background: 'rgba(238,169,169,1)',
				fontColor: '#5c5d58',
				background: '#E3EDCD',
				readePattern: 0,
				pagingPattern: 1, //默认翻页方式
				bootPage: 0,
				clWidth: document.documentElement.clientWidth || document.body.clientWidth,

				bookId: '',
				readIdFirst: '',
				pageurl: '',
				soltPhDetailIndex: '',
				next_chapter: '',
				last_chapter: '',
				bgc_set_show: false,
				musice_box: false,
				book_details: {},
				activeid: 0,
				allMFzj: false, //剩余免费章节
				getSecondtab: '',
				getFirstvaluetab: '',
				stepSet: 0,
				changeSlideRead: '',
				solt_reverse: false,
				lang: localStorage.getItem('lang'), //简繁体切换
				isTraditional: true,
				isLlock: true, //竖屏true，横屏false
				leftnavText: '查看全部',
				tostShowBox: false, //弹框(打赏)
				yunjinbiList: [{
						txt: '流星',
						jinbi: '100云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds01.png')
					},
					{
						txt: '卫星',
						jinbi: '500云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds02.png')
					},
					{
						txt: '行星',
						jinbi: '1000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds03.png')
					},
					{
						txt: '恒星',
						jinbi: '2000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds04.png')
					},
					{
						txt: '彗星',
						jinbi: '5000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds05.png')
					},
					{
						txt: 'M78星云',
						jinbi: '10000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds06.png')
					},
					{
						txt: '银河系',
						jinbi: '100000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds07.png')
					},
					{
						txt: '琼浆玉露',
						num: '20',
						imgUrl: require('../../assets/img/ds08.png')
					},
					{
						txt: '琼浆玉露',
						num: '60',
						imgUrl: require('../../assets/img/ds08.png')
					}
				],
				itemyunjinbi: -1, //云锦币
				userInfo: {},
				queryTitle: '2',
				selectItemList: [{
						txt: '2',
					},
					{
						txt: '1',
					},
					{
						txt: '0',
					},
					{
						txt: '-1',
					},
					{
						txt: '-2',
					},
				],
        		tabSubscribechapter:false,
				queryIndex: ' ', //排序选择
				selectItem: false,
				ds_chapterId: '',
				ds_bookId: '',
				transitionDuration: '0s',
				show: false,
				fileTxt: '',
				fileName: '',
				fileList: [],
				ds_value: '',
				book_comments: [],
				chapter_id: '', //章节id
				chapter_num: '', //章节数量
				height_scroll: 0, //滚动距离
				sq_show: true,
				moveX: 0,
				moveY: 0,
				startX: 0,
				startY: 0,
				scInfoData: [],
				readBookShow: true,
				vipBooks_name: '', //vip 书本名称
				vipNumber: 0, //vip 章节数
				vipTitle: '', //vip 章节标题
				vip_cost: 0, // vip 购买章节数量
				vipUser_money: '0.00', // 用户余额
				btn_list_val: [{
						a: '订阅本章',
						b: '云锦币'
					},
					'批量订阅'
				],
				ismove: false,
				X: 0,
				scrollable: false,
				user_id: '',
				get_c_score: [],
				c_score: 2,
				books_id_jump: '',
				lock_status_jump: '',
				lock_id_jump: '',
				is_vip_jump: '',
				userInfoUsername: '',
				readCacheList: [], //阅读缓存列表

				readInfoData: {},
				scCode: 0,
				
				synth: null,
				speakMsg: null,
				intaBook: 0,
				
				isSpeaking: 'STOP'
				
			}
		},
		computed: {
			...mapGetters(['book'])
		},
		created() {
			console.log("打印进入了了readbook created")
			this.$parent.setComponent(this);
			var _t = this;
			setInterval(function() {
				let dateTxt = new Date();
				_t.dateTime = _t.fixZero(dateTxt.getHours(), 2) + ":" + _t.fixZero(dateTxt.getMinutes(), 2);
			}, 1000);
			if (localStorage.getItem('lang')) {
				if (localStorage.getItem('lang') == 't') {
					_t.isTraditional = false;
				} else {
					_t.isTraditional = true;
				}
			}
			if (JSON.parse(localStorage.getItem('userInfoData')) != undefined) {
				_t.userInfoUsername = JSON.parse(localStorage.getItem('userInfoData')).nickname || '';
			}
			//初始化 简繁体问题
			_t.transitionDuration = localStorage.getItem('transitionDuration');
			_t.bookId = _t.$route.query.id || _t.$route.query.books_id || '';
			_t.readIdFirst = Number(_t.$route.query.readId) || '';
			_t.readIdFirstNum = _t.$route.query.readNum;
			_t.pageurl = _t.$route.query.pageurl || _t.$route.query.numberBookInfo; //跳转页面标识
			// alert(_t.readIdFirst, 'readId')
			_t.soltPhDetailIndex = _t.$route.query.index || _t.$route.query.ydid || _t.$route.query.readId;

			_t.getSecondtab = _t.$route.query.getSecond_tab;
			_t.getFirstvaluetab = _t.$route.query.getFirstvalue_tab;

			_t.chapter_id = _t.readIdFirst; //章节id
			_t.chapter_num = _t.readIdFirstNum; //章节数量
			_t.readCacheList.push({
				chapter_id: _t.chapter_id,
				chapter_num: _t.chapter_num,
				bookId: _t.bookId
			})

			// debugger
			// if(localStorage.getItem('readCacheList') != "null"){
			// 	let arr = localStorage.getItem(JSON.parse(readCacheList))
			// 	var newArr = arr.concat(_t.readCacheList)
			// 	localStorage.setItem("readCacheList",JSON.stringify(newArr))
			// }else{
			// 	localStorage.setItem("readCacheList",JSON.stringify(_t.readCacheList))
			// }

			_t.books_id_jump = _t.$route.query.books_id_jump;
			_t.lock_status_jump = _t.$route.query.lock_status_jump
			_t.lock_id_jump = _t.$route.query.lock_id_jump;
			_t.is_vip_jump = _t.$route.query.is_vip_jump;
			_t.activeid = _t.soltPhDetailIndex;
			//本地文件
			if (_t.$route.query.fileIdx != undefined) {
				console.log("打印进入了缓存 获取本地文件  ")
				_t.fileList = JSON.parse(localStorage.getItem('fileList'));
				if (_t.fileList != []) {
					_t.fileTxt = _t.fileList[_t.$route.query.fileIdx].fileTxt;
					_t.fileName = _t.fileList[_t.$route.query.fileIdx].fileName;
					_t.bookContent.push(_t._nromalBook(_t.fileName, typeof _t.fileTxt === 'string'?_t.fileTxt.replace('/\n\n/g', '\n'):_t.fileTxt, '', '', '', ''))
					console.log("打印 bookContent  " + JSON.stringify(_t.bookContent))
				}
				// else {
				// 	_t.get_book_detail();
				// }
			} else {
				_t.init();
				if (_t.bookId != '') {
					_t.get_book_detail();
				}
			}

			// this.getNewUser();

			// if(this.readIdFirst != ''){

			// }

			// if (localStorage.getItem('scRadio') == true && localStorage.getItem('scRadio') != undefined) {
			// 	this.showSc = true; //收藏弹窗
			// } else {
			// 	this.showSc = false; //收藏弹窗
			// }
			this.percent = 30 * 0.3;

			let localShelfSet = JSON.parse(localStorage.getItem('userSet')) || null;
			if (localShelfSet != null) {
				_t.fontSize = localShelfSet.fontSize;
				_t.background = localShelfSet.background;
				_t.fontColor = localShelfSet.color;
				_t.readePattern = localShelfSet.readePattern;
				_t.pagingPattern = localShelfSet.pagingPattern;
				_t.lineHeight = localShelfSet.lineHeight;
			}
			// this.changeSlideRead = localStorage.getItem('onChangeReadVal')
			// 打赏获取章节id
			_t.ds_chapterId = Number(_t.$route.query.readId);
			_t.ds_bookId = _t.$route.query.id || _t.$route.query.books_id;
			//横屏初始化
			localStorage.setItem('isLlock', true); //默认竖屏
			window.electricity = _t.electricity; //默认电量显示
			
			
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					that.clWidth = document.body.clientWidth;
					that.$router.go(0)
				})()
			};
			// that.$on('bridge',(actvie_btn1)=>{
			//      that.subscribechapter(actvie_btn1);
			// });
			if (that.pagingPattern === 1) {
				that.$nextTick(function() {
					if (that.$refs.bookInner != undefined) {
						for (var i = 0; i < that.$refs.bookInner.length; i++) {
							let scrollW = that.$refs.bookInner[0].scrollWidth;
							let clientW = that.$refs.bookInner[0].clientWidth;
							// alert(scrollW,clientW);
							that.resultPaging = Math.floor(scrollW / clientW);
						}
					}

					if (that.isClickPage) {
						that.currentPaging = that.resultPaging;
						that.offsetX = -(that.currentPaging - 1) * (that.clWidth - that.margin);
						that.styleObject = {
							'-webkit-transform': 'translateX(' + that.offsetX + 'px' + ')',
							transitionDuration: '0s'
						};
					}
				});
			}
			// 打赏
			that.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))

			that.user_id = JSON.parse(localStorage.getItem('userInfoData')).user_id || '';
			window.addEventListener('scroll', that.handleScroll);

			window.electricity = that.electricity;
			if (that.$webapp.isAndroid) {
				console.log("安卓 mounted")
				that.range = window.android.getbrightness(); //获取亮度 --- 安卓
				window.android.onBatteryInfo(); //请求电量
				window.android.setTransparentHide(true) //状态栏隐藏
				// $Android.setTransparentHide(true)
			} else if (that.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		updated() {
			// if (this.pagingPattern === 1) {
			// this.$nextTick(function() {
			// for (var i = 0; i < this.$refs.bookInner.length; i++) {
			// 	let scrollW = this.$refs.bookInner[0].scrollWidth;
			// 	let clientW = this.$refs.bookInner[0].clientWidth;
			// 	// alert(scrollW,clientW);
			// 	this.resultPaging = Math.floor(scrollW / clientW);
			// }
			// if (this.isClickPage) {
			// 	this.currentPaging = this.resultPaging;
			// 	this.offsetX = -(this.currentPaging - 1) * (this.clWidth - this.margin);
			// 	this.styleObject = {
			// 		'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
			// 		transitionDuration: '0s'
			// 	};
			// }
			// });
			// }
		},
		methods: {
			subscribechapter(actvie_btn1) {

				console.log(this.activeid,this.chapter_id,this.books_id_jump,this.lock_status_jump,this.lock_id_jump,this.is_vip_jump,this.chapter_num)
				console.log(this.activeid != 0 ? this.activeid : this.chapter_id)
        // return
				if (actvie_btn1 == 0 && this.vipNumber != 0) {
					if (this.vipUser_money == '0.00') {
						Toast('您的余额不足请到我的-云锦币充值进行充值后操作');
						return false;
					} 
					// 防止重复订阅
					if (this.tabSubscribechapter){
					Toast('订阅中，请勿重复订阅');
					return
					}
					this.tabSubscribechapter = true

					this.$axios.post(this.$api.batch_buy, {
						chapter_ids: this.chapter_id
					}).then(res => {
						Toast(res.data.msg);
						this.listOption = !this.listOption;
						this.jumpReadbook(this.chapter_id, this.books_id_jump, this.lock_status_jump, this
							.lock_id_jump, this.is_vip_jump,
							this.chapter_num);
					}).catch((error)=>{
						this.tabSubscribechapter = false
            		});
				} else if (actvie_btn1 == 1 && this.vipNumber != 0) {
					if (this.vipUser_money == '0.00') {
						Toast('您的余额不足请到我的-云锦币充值进行充值后操作');
						return false;
					} else {
						this.$router.push({
							path: '/pldy',
							query: {
								readId: this.bookId
							}
						})
					}
				}
			},
			//获取电量
			electricity(percent) {
				this.percent = percent * 0.3;
			},
			fixZero(num, length) {
				var str = "" + num;
				var len = str.length;
				var s = "";
				for (var i = length; i-- > len;) {
					s += "0";
				}
				return s + str;
			},
			// 删除书签
			showDeleteButtonFn(id) {
				// this.show_ldBox = false;
				clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
				this.Loop = setTimeout(function() {
					Dialog.confirm({
							// title: '',
							message: '删除该条书签',
						})
						.then(() => {
							this.$axios.post(this.$api.del_bookmark, {
								mark_id: id
							}).then(res => {
								Toast(res.data.msg);
								this.get_book_detail()
							})

						})
						.catch(() => {
							// on cancel
						});
				}.bind(this), 1000);
			},
			emptyTime() {
				clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
			},
			changeSpeed(e) {
				console.log(JSON.stringify(e))
				console.log(JSON.stringify(this.speed))
				$Android.stopSpeaking();
				$Android.speakStartPlay(this.bookContent[0].contentList[this.intaBook],this.speed);
				// ttsRecorder.speed = this.speed
				// console.log(ttsRecorder)
			},
			// Android调用js方法
			callJsFuncTTS(){
				this.isSpeaking = 'STOP';
				document.getElementById(this.intaBook + '').style.backgroundColor = "";
				Toast('当前设备不支持小说朗读功能!');
				return "js调用成功";
			},
			// Android调用js方法
			callJsFunc() {
				var that = this;
				console.log("打印Android原生调用了vue中的js方法");
				if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = ""
				this.intaBook += 1;
				//最后一段的时候
				if(that.intaBook == that.bookContent[0].contentList.length - 2){
					console.log("播放结束  最后一段的时候 ")
					that.getTTSNextChapter()
					if(that.isElementInViewport(document.getElementById('' + that.intaBook))){
						console.log("播放结束  最后一段的时候 33333 ")
						//如果在当前窗口展示不进行处理
					}else{
						console.log("播放结束  最后一段的时候 44444  ")
						//不在当前窗口展示，进行跳转下一页处理
						that.ttsPageFunc(false)
					}
				}else if(that.intaBook < that.bookContent[0].contentList.length - 2){
					console.log("播放结束  2222 ")
					if(that.isElementInViewport(document.getElementById('' + that.intaBook))){
						console.log("播放结束 33333 ")
						//如果在当前窗口展示不进行处理
					}else{
						console.log("播放结束 44444  ")
						//不在当前窗口展示，进行跳转下一页处理
						that.ttsPageFunc(false)
					}
				}else{
					console.log("播放结束 播放下一章  ")
					if(that.bookCacheContent.length <= 0){
						return
					}
					that.bookContent[0] = that.bookCacheContent[0]
					that.intaBook = 0
					if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
					that.styleObject = '';
					that.offsetX = 0;
					that.bookCurrentPage++;
					that.currentPaging = 1;
					that.bookCacheContent = []
				}
				$Android.speakStartPlay(this.bookContent[0].contentList[this.intaBook],this.speed);
				if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
				return "js调用成功";
			},
			//Android tts播放的功能
			androidTTSPlay(){
				var that = this;
				// $Android存在
				//Android原生代码中tts的初始化方法
				// $Android.androidTtsInit();
				for (var i = 0; i < this.bookContent[0].contentList.length; i++) {
					if(this.isElementInViewport(document.getElementById('' + i))){
						this.intaBook = i;
						if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
						$Android.speakStartPlay(this.bookContent[0].contentList[this.intaBook],this.speed);
						break;
					}
				}
			},
			//Android 客户端tts暂停 播放的方法
			audioAndroidFnPause(){
				if(this.isSpeaking == 'PAUSE'){
					this.isSpeaking = 'SPEAK';
					$Android.resumeSpeaking(this.bookContent[0].contentList[this.intaBook]);
				}else if(this.isSpeaking == 'SPEAK'){
					this.isSpeaking = 'PAUSE';
					$Android.pauseSpeaking();
				}else{
					this.isSpeaking = 'SPEAK';
					this.androidTTSPlay();
				}
			},
			//暂停 开启的功能
			audiovalueFnPause(inta){
				this.musice_box = false;
				
				// if(inta == 0){//女声音
					
				// }else if(inta == 1){//男声音
					
				// }
				if (typeof $Android !== 'undefined') {
					this.audioAndroidFnPause()
				}else{
					this.wapTTSFnPause()
				}
			},
			//wap tts暂停 播放的方法
			wapTTSFnPause(){
				if(this.synth){
					if(this.isSpeaking == 'PAUSE'){
						this.isSpeaking = 'SPEAK'
						this.synth.resume();
					}else if(this.isSpeaking == 'SPEAK'){
						this.isSpeaking = 'PAUSE'
						this.synth.pause();
					}
				}else{
					this.isSpeaking = 'SPEAK'
					this.ttsPageLangdu()
				}
			},
			isElementInViewport(element){
				const rect = element.getBoundingClientRect();
				return (
				    rect.top >= 0 &&
				    rect.left >= 0 &&
				    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
			},
			ttsPageLangdu(){
				for (var i = 0; i < this.bookContent[0].contentList.length; i++) {
					if(this.isElementInViewport(document.getElementById('' + i))){
						this.intaBook = i
						var that = this
						if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
						if(this.synth){
							console.log('重启播放 不为空')
							this.handleSpeak(this.bookContent[0].contentList[this.intaBook])
						}else{
							this.synth = window.speechSynthesis;
							// 监听speaking状态变化
							this.speakMsg = new SpeechSynthesisUtterance();
							this.speakMsg.onend = function(){
								console.log("播放结束")
								if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = ""
								that.intaBook = that.intaBook + 1
								
								//最后一段的时候
								if(that.intaBook == that.bookContent[0].contentList.length - 2){
									console.log("播放结束  最后一段的时候 ")
									that.getTTSNextChapter()
									if(that.isElementInViewport(document.getElementById('' + that.intaBook))){
										console.log("播放结束  最后一段的时候 33333 ")
										//如果在当前窗口展示不进行处理
									}else{
										console.log("播放结束  最后一段的时候 44444  ")
										//不在当前窗口展示，进行跳转下一页处理
										that.ttsPageFunc(false)
									}
								}else if(that.intaBook < that.bookContent[0].contentList.length - 2){
									console.log("播放结束  2222 ")
									if(that.isElementInViewport(document.getElementById('' + that.intaBook))){
										console.log("播放结束 33333 ")
										//如果在当前窗口展示不进行处理
									}else{
										console.log("播放结束 44444  ")
										//不在当前窗口展示，进行跳转下一页处理
										that.ttsPageFunc(false)
									}
								}else{
									console.log("播放结束 播放下一章  ")
									if(that.bookCacheContent.length <= 0){
										return
									}
									that.bookContent[0] = that.bookCacheContent[0]
									that.intaBook = 0
									if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
									that.styleObject = '';
									that.offsetX = 0;
									that.bookCurrentPage++;
									that.currentPaging = 1;
									that.bookCacheContent = []
								}
								that.handleSpeak(that.bookContent[0].contentList[that.intaBook])
								if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "#DCD1B0"
							};
							this.handleSpeak(this.bookContent[0].contentList[this.intaBook])
							//阅读最后一段落
							if(this.intaBook == that.bookContent[0].contentList.length - 2){
								console.log("直接播放  最后一段的时候 ")
								this.getTTSNextChapter()
							}
						}
						break;
					}
				}
			},
			// 语音播报的函数
			/**
			*  text – 要合成的文字内容，字符串
			* lang – 使用的语言，字符串， 例如：“zh-cn”
			* voiceURI – 指定希望使用的声音和服务，字符串
			* volume – 声音的音量，区间范围是0到1，默认是1
			* rate – 语速，数值，默认值是1，范围是0.1到10，表示语速的倍数，例如2表示正常语速的两倍。
			* pitch – 表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1
			*/
			handleSpeak(text){
				if (this.synth) {
				        this.synth.cancel(); 
				    }
			  this.speakMsg.text = text;
			  this.speakMsg.lang = 'zh-CN';
			  this.speakMsg.volume = '1';
			  // this.speakMsg.rate = this.speed >= 50?(1 + (this.speed/50 - 1) * 5):(this.speed <= 5?0.1:this.speed/50);
			  this.speakMsg.rate = this.speed; 
			  this.speakMsg.pitch = 1;
			  this.synth.speak(this.speakMsg);
			},
			handleScroll() {
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
			},
			collect_chapterFn() {
				this.sq_show = !this.sq_show;
				// alert(this.chapter_id + '章节id')
				this.$axios.post(this.$api.collect_chapter, {
					chapter_id: this.chapter_id
				}).then(res => {
					Toast(res.data.msg);
					if (res.data.data == 200) {
						this.sq_show = false;
						this.scCode = 1;
						this.readInfoData.type = 2
					} else if (res.data.data == 201) {
						this.sq_show = false;
						this.scCode = 1;
						this.readInfoData.type = null
					}
					this.chapterType = res.data.data;
					this.chapterList.push(this.chapter_id);
					this.get_book_detail();
				})
			},
			// scRadioFn(){
			// 	this.showSc = false;
			// },
			// 评论fn
			toComment() {
				this.$router.push({
					path: '/comment',
					query: {
						book_id: this.bookId,
						chapter_num: this.chapter_num,
						book_comments: this.book_comments,
						chapter_id: this.chapter_id,
					}
				})
			},
			pldyFn() {
				if (this.book_details.vip_chapter_count != 0) {
					this.$router.push({
						path: '/pldy',
						query: {
							book_id: this.bookId,
						}
					})
				} else {
					Toast('此文还没有入V哦,点击收藏，助大大早日入V')
				}
			},
			stopFn() {
				console.log("打印stop")
				var that = this;
				if(typeof $Android !== 'undefined'){
					$Android.stopSpeaking();
					if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "";
					this.intaBook = 0;
					this.isSpeaking = "STOP";
				}else{
					if(this.synth){
						// this.synth.pause();
						this.synth.cancel();
						this.synth = null;
						this.speakMsg = null;
						this.isSpeaking = "STOP";
						if(document.getElementById(that.intaBook + '')) document.getElementById(that.intaBook + '').style.backgroundColor = "";
						this.intaBook = 0;
					}
				}
				this.musice_box = false;
			},
			setBrightnessFn(range) {
				if (this.$webapp.isAndroid) {
					console.log("安卓")
					window.android.brightness(range) //安卓 -- 设置亮度
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
				// // console.log(range)
				// // 获取屏幕亮度   0 - 1之间的数值
				// plus.screen.getBrightness();
				// // 设置屏幕亮度
				// plus.screen.setBrightness(range);
			},
			xtFontFn() {
				Toast('该功能暂未开通')
			},
			bgcSon() {
				this.fontColor = '#5c5d58';
				this.background = '#E3EDCD';
				this.show = false;
				this.setUserLocalStorage();
			},
			bgcNight() {
				this.fontColor = '#ffffff';
				this.background = '#000000';
				this.show = true;
				this.setUserLocalStorage();
			},
			scbtnFn(inx) { //收藏
				console.log(inx);
				this.scindex = inx;
				this.showSc = false;
				if (inx == 1) {
					this.$axios.post(this.$api.xianmian_collect, {
						books_ids: this.bookId
					}).then(res => {
						Toast(res.data.msg)
					})
					// 返回
					if (localStorage.getItem('isLlock') == 'true') {
						if (this.$route.query.fileIdx != undefined) {
							this.$router.push('/bookshelf')
						} else if (this.pageurl == 'bookdyinfo') {
							this.$router.push({
								path: '/bookinfo',
								query: {
									id: this.bookId,
									url: this.pageurl,
									soltPhDetailIndex: this.soltPhDetailIndex,
									getSecond_tab: this.getSecondtab,
									getFirstvalue_tab: this.getFirstvaluetab,
									active: this.$route.query.active,
								}
							})
						} else {
							this.$router.go(-1);
						}
					} else if (localStorage.getItem('isLlock') == 'false') {
						if (this.$webapp.isAndroid) {
							console.log("安卓")
							window.android.setorientation(1); //竖屏
							this.isLlock = true;
						} else if (this.$webapp.isiOS) {
							console.log("苹果")
						}
						localStorage.setItem('isLlock', true)
					} else {
						this.$router.go(-1);

					}
					if (this.scRadio == true) {
						this.showSc = false;
						this.scInfoData.push({
							scBookID: this.bookId,
							scRadio: true,
							scinx: 1
						})
						localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
					} else if (this.scRadio == false) {
						this.showSc = true;
						this.scInfoData.push({
							scBookID: this.bookId,
							scRadio: false,
							scinx: 1
						})
						localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
					}
				} else if (inx == 0) {
					// 返回
					if (localStorage.getItem('isLlock') == 'true') {
						if (this.$route.query.fileIdx != undefined) {
							this.$router.push('/bookshelf')
						} else if (this.pageurl == 'bookdyinfo') {
							this.$router.push({
								path: '/bookinfo',
								query: {
									id: this.bookId,
									url: this.pageurl,
									soltPhDetailIndex: this.soltPhDetailIndex,
									getSecond_tab: this.getSecondtab,
									getFirstvalue_tab: this.getFirstvaluetab,
									active: this.$route.query.active,
								}
							})
						} else {
							this.$router.go(-1);
						}
					} else if (localStorage.getItem('isLlock') == 'false') {
						if (this.$webapp.isAndroid) {
							console.log("安卓")
							window.android.setorientation(1); //竖屏
							this.isLlock = true;
						} else if (this.$webapp.isiOS) {
							console.log("苹果")
						}
						localStorage.setItem('isLlock', true)
					} else {
						this.$router.go(-1);

					}
					if (this.scRadio == true) {
						this.showSc = false;
						this.scInfoData.push({
							scBookID: this.bookId,
							scRadio: true,
							scinx: 0
						})
						localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
					} else if (this.scRadio == false) {
						this.showSc = true;
						this.scInfoData.push({
							scBookID: this.bookId,
							scRadio: false,
							scinx: 0
						})
						localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
					}
				}
			},
			back() {
				// 清除横屏显示及数据(plus在web端会报错，只有手机端才能正常运行)
				// if (localStorage.getItem('isLlock')) {
				// 	localStorage.removeItem('isLlock');
				// 	plus.screen.lockOrientation("portrait-primary");
				// }
				// if(this.book_details.is_collect == 1){
				// 	this.showSc = false;
				// }else{
				// 	this.showSc = true;
				// }
				this.stopFn();
				this.scInfoData = JSON.parse(localStorage.getItem('scRadio')) != undefined ? JSON.parse(localStorage
					.getItem(
						'scRadio')) : [];
				if (this.scInfoData != [] && this.book_details.is_collect != 1) {
					this.showSc = true;
					this.scInfoData.forEach(item => {
						if (item.scRadio == true && item.scBookID == this.bookId && item.scinx == 0) {
							this.showSc = false; //收藏弹窗
							if (localStorage.getItem('isLlock') == 'true') {
								this.bgc_set_show = false;
								if (this.$route.query.fileIdx != undefined) {
									this.$router.push('/bookshelf')
								} else if (this.pageurl == 'bookdyinfo') {
									this.$router.push({
										path: '/bookinfo',
										query: {
											id: this.bookId,
											url: this.pageurl,
											soltPhDetailIndex: this.soltPhDetailIndex,
											getSecond_tab: this.getSecondtab,
											getFirstvalue_tab: this.getFirstvaluetab,
											active: this.$route.query.active,
										}
									})
								} else {
									this.$router.go(-1);
								}
							} else if (localStorage.getItem('isLlock') == 'false') {
								if (this.$webapp.isAndroid) {
									console.log("安卓")
									window.android.setorientation(1); //竖屏
									this.isLlock = true;
								} else if (this.$webapp.isiOS) {
									console.log("苹果")
								}
								localStorage.setItem('isLlock', true)
							} else {
								this.$router.go(-1);

							}
						} else if (item.scRadio == true && item.scBookID == this.bookId && item.scinx == 1) {
							this.showSc = false; //收藏弹窗
							if (localStorage.getItem('isLlock') == 'true') {
								this.bgc_set_show = false;
								if (this.$route.query.fileIdx != undefined) {
									this.$router.push('/bookshelf')
								} else if (this.pageurl == 'bookdyinfo') {
									this.$router.push({
										path: '/bookinfo',
										query: {
											id: this.bookId,
											url: this.pageurl,
											soltPhDetailIndex: this.soltPhDetailIndex,
											getSecond_tab: this.getSecondtab,
											getFirstvalue_tab: this.getFirstvaluetab,
											active: this.$route.query.active,
										}
									})
								} else {
									this.$router.go(-1);
								}
							} else if (localStorage.getItem('isLlock') == 'false') {
								if (this.$webapp.isAndroid) {
									console.log("安卓")
									window.android.setorientation(1); //竖屏
									this.isLlock = true;
								} else if (this.$webapp.isiOS) {
									console.log("苹果")
								}
								localStorage.setItem('isLlock', true)
							} else {
								this.$router.go(-1);

							}
						} else if (item.scRadio == false && item.scinx == 0 || this.book_details.is_collect == 0) {
							this.showSc = true; //收藏弹窗
						} else if (item.scRadio == false && item.scinx == 1 || this.book_details.is_collect == 0) {
							this.showSc = true; //收藏弹窗
						} else if (item.scRadio != true && item.scBookID != this.bookId || this.book_details
							.is_collect == 0) {
							this.showSc = true; //收藏弹窗
						} else if (this.book_details.is_collect == 0) {
							this.showSc = true;
						}
					})
				} else if (this.book_details.is_collect == 1) {
					this.showSc = false;
					this.bgc_set_show = false;
					if (localStorage.getItem('isLlock') == 'false') {
						if (this.$webapp.isAndroid) {
							console.log("安卓")
							window.android.setorientation(1); //竖屏
							this.isLlock = true;
						} else if (this.$webapp.isiOS) {
							console.log("苹果")
						}
						localStorage.setItem('isLlock', true)
					}
					this.$router.go(-1);
					return false;
				}
				if (this.$route.query.fileIdx != undefined) {
					this.$router.go(-1);
				}
			},
			// 更多
			moresetPage() {
				this.$router.push({
					path: '/moreset',
					query: {
						readId: this.$route.query.readId,
						id: this.$route.query.id,
						pageurl: this.$route.query.pageurl
					}
				})
			},
			mltostHideFn() {
				this.listOption = !this.listOption
			},
			mltostShow() {
				// this.listOption = !this.listOption
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: this.bookId,
						bookshelfUrl: this.pageurl,
						soltPhDetailIndex: this.soltPhDetailIndex,
						getSecond_tab: this.getSecondtab,
						getFirstvalue_tab: this.getFirstvaluetab,
						active: this.$route.query.active,
					}
				})
			},
			init() {
				if (this.readIdFirst == '' && this.$route.query.fileIdx == undefined) {
					this.$axios.post(`${this.$api.read}?books_id=${this.$route.query.books_id}`).then(res => {
						if (res.data.data == null) {
							this.readInfoData.type = 0;
							Toast(res.data.msg);
							return false;
						} else {
							this.readInfoData = res.data.data;
							if (this.readInfoData.type == 2) {
								this.chapterType = 200;
							} else {
								this.chapterType = 201;
							}
							if (res.data.data == null) {
								this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
								Toast(res.data.msg);
								return false
							} else if (res.data.code == 0) {
								this.readBookShow = false;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;

								this.vipBooks_name = res.data.data.books_name;
								this.vipNumber = res.data.data.number || 0;
								this.vipTitle = res.data.data.title;
								this.vip_cost = res.data.data.vip_cost || 0;
								this.vipUser_money = res.data.data.user_money || '0.00';

							} else {
								this.readBookShow = true;
								this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content, res.data.data.number, res.data.data.books_name, res.data.data.location_status, res.data.data.narrate))
								this.dqpage = res.data.data.id;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;
								console.log(this.bookContent, 'this.bookContent 019')

								//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
								var _t = this;
								// setTimeout(function() {
								// 	if (localStorage.getItem('lang')) {
								// 		_t.$zh_tran(localStorage.getItem('lang'));
								// 	}
								// })
							}
						}



					})
				} else if (this.$route.query.fileIdx == undefined) {
					this.$axios.post(`${this.$api.read}?chapter_id=${this.readIdFirst}`).then(res => {
						if (res.data.data != null) {
							this.readInfoData = res.data.data;
							if (this.readInfoData.type == 2) {
								this.sq_show = false;
							} else {
								this.sq_show = true;
							}
							if (res.data.data == null) {
								this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
								Toast(res.data.msg);
								return false

							} else if (res.data.code == 0) {
								this.readBookShow = false;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;

								this.vipBooks_name = res.data.data.books_name;
								this.vipNumber = res.data.data.number;
								this.vipTitle = res.data.data.title;
								this.vip_cost = res.data.data.vip_cost;
								this.vipUser_money = res.data.data.user_money;
							} else {
								this.readBookShow = true;
								this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content,
										res.data.data.number, res.data
										.data.books_name, res.data.data.location_status, res.data.data.narrate
										))
								this.dqpage = res.data.data.id;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;
								// console.log(this.bookContent, 'this.bookContent 019 1433')

								//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
								var _t = this;
								// setTimeout(function() {
								// 	if (localStorage.getItem('lang')) {
								// 		_t.$zh_tran(localStorage.getItem('lang'));
								// 	}
								// })
							}
						} else {
							this.readInfoData.type = 0;
							Toast(res.data.msg);
							return false;
						}
					})

				}
			},
			//获取是否为新用户，新用户的则需要引导页
			// getNewUser() {
			// 	console.log(JSON.parse(window.localStorage.getItem('bootPage')), 'getNewUser')
			// 	let localShelf = JSON.parse(window.localStorage.getItem('bootPage')) ? JSON.parse(window.localStorage.getItem(
			// 		'bootPage')) : {};
			// 	console.log(localShelf, '新用户的则需要引导页')
			// 	if (localShelf.bootPage) {
			// 		this.bootPage = localShelf.bootPage
			// 	} else {
			// 		this.bootPage = 0;
			// 	}
			// },
			//引导页
			setBootPage() {
				console.log('引导页------引导页----引导页');
				// let localShelf = JSON.parse(window.localStorage.getItem('bootPage')) ? JSON.parse(window.localStorage.getItem(
				// 	'bootPage')) : {};
				localShelf = {
					bootPage: 1
				};
				this.bootPage = 1;
				window.localStorage.setItem('bootPage', JSON.stringify(localShelf));
			},
			//获取用户设置
			getUserLocalStorage() {
				let localShelf = JSON.parse(window.localStorage.getItem('userSet')) ? JSON.parse(window.localStorage
					.getItem(
						'userSet')) : {};
				this.fontSize = localShelf.fontSize;
				this.background = localShelf.background;
				this.fontColor = localShelf.color;
				this.readePattern = localShelf.readePattern;
				this.pagingPattern = localShelf.pagingPattern;
				this.lineHeight = localShelf.lineHeight;
			},
			//将用户设置进行缓存
			setUserLocalStorage() {
				// debugger;
				let localShelf = JSON.parse(window.localStorage.getItem('userSet')) ? JSON.parse(window.localStorage
					.getItem(
						'userSet')) : {};
				localShelf = {
					fontSize: this.fontSize,
					background: this.background,
					color: this.fontColor,
					readePattern: this.readePattern,
					pagingPattern: this.pagingPattern,
					lineHeight: this.lineHeight,
				};
				console.log(localShelf, 'localShelf');
				localStorage.setItem('userSet', JSON.stringify(localShelf));
			},
			//翻页模式设置
			// setPaging(num) {
			// 	console.log(num, 'num')
			// 	this.option = !this.option;
			// 	// alert(this.option)
			// 	this.pagingPattern = num;
			// 	this.setUserLocalStorage();
			// 	if (this.pagingPattern === 1) {
			// 		this.$nextTick(function() {
			// 			for (var i = 0; i < this.$refs.bookInner.length; i++) {
			// 				let scrollW = this.$refs.bookInner[0].scrollWidth;
			// 				let clientW = this.$refs.bookInner[0].clientWidth;
			// 				this.resultPaging = Math.floor(scrollW / clientW);
			// 			}
			// 			console.log(this.resultPaging, 'this.resultPaging')
			// 		})

			// 	}
			// },
			//阅读模式设置
			setPattern(item, index) {
				// this.option = true;
				this.readePattern = index;
				console.log(this.readePattern, 'readePattern')
				this.fontColor = item.color;
				this.background = item.background;
				console.log(this.background)
				this.setUserLocalStorage()
			},
			//字体设置
			fontSet(str) {
				if (str === 'reduce') {
					if (this.fontSize === 14) {
						return
					} else {
						this.fontSize -= 0.8
						this.setUserLocalStorage()
					}
				}
				if (str === 'add') {
					if (this.fontSize === 22) {
						return
					} else {
						this.fontSize += 0.8
						this.setUserLocalStorage()
					}
				}
			},
			lineHeightSet(str) {
				if (str === 'reduce') {
					if (this.lineHeight === 41) {
						return
					} else {
						this.lineHeight -= 1
						this.setUserLocalStorage()
					}
				}
				if (str === 'add') {
					if (this.lineHeight === 60) {
						return
					} else {
						this.lineHeight += 1
						this.setUserLocalStorage()
					}
				}
			},
			paddingSet(str) {
				Toast('此功能暂未开启');
				// if (str === 'reduce') {
				// 	if (this.lineHeight === 10) {
				// 		return
				// 	} else {
				// 		this.lineHeight -= 2
				// 		this.setUserLocalStorage()
				// 	}
				// }
				// if (str === 'add') {
				// 	if (this.lineHeight === 16) {
				// 		return
				// 	} else {
				// 		this.lineHeight += 2
				// 		this.setUserLocalStorage()
				// 	}
				// }
			},
			//切换目录 catalogFn
			selectChapter(index) {
				this.isClickPage = false;
				this.moreLoading = false;
				this.loading = true;
				// Toast.loading({
				// 	message: '加载中...',
				// 	forbidClick: true,
				// });
				// this.showSc = true; //收藏弹窗
				this.bookSource = [];
				this.bookCurrentPage = index;
				this.currentPaging = 1;
				this.offsetX = 0;
				this.styleObject = {
					'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
					transitionDuration: this.transitionDuration
				};

			},

			setList() {
				this.listOption = !this.listOption;
				this.scrollable = true;
				if (!this.option) {
					return
				}
				this.option = !this.option;
				if (this.option == true) {
					window.android.setTransparentHide(false)
					// $Android.setTransparentHide(false)
				} else if (this.option == false) {
					window.android.setTransparentHide(true)
					// $Android.setTransparentHide(true)
				}
			},
			set() {
				this.bgc_set_show = !this.bgc_set_show;
				if (!this.option) {
					return
				}
				this.option = !this.option;
				if (this.option == true) {
					window.android.setTransparentHide(false)
					// $Android.setTransparentHide(false)
				} else if (this.option == false) {
					window.android.setTransparentHide(true)
					// $Android.setTransparentHide(true)
				}
			},
			setmusice() {
				this.musice_box = !this.musice_box;
				if (!this.option) {
					return
				}
				this.option = !this.option;
				if (this.option == true) {
					window.android.setTransparentHide(false)
					// $Android.setTransparentHide(false)
				} else if (this.option == false) {
					window.android.setTransparentHide(true)
					// $Android.setTransparentHide(true)
				}
				//初始化Android tts
				
			},
			setReadShow() {
				this.option = !this.option
				if (this.option == true) {
					window.android.setTransparentHide(false)
					// $Android.setTransparentHide(false)
				} else if (this.option == false) {
					window.android.setTransparentHide(true)
					// $Android.setTransparentHide(true)
				}
			},
			touchstart(e) {
				// 如果你要阻止点击事件，请反注释下一行代码
				e.preventDefault();
				this.ismove = false;
				// this.startX = e.touches[0].clientX
				// this.startY = e.touches[0].clientY;
				// this.ismove = false;
				this.startX = e.changedTouches[0].pageX
			},
			touchmove(e) {
				// let clWidth = document.documentElement.clientWidth || document.body.clientWidth;
				// let currentX = e.pageX;
				// let offsetX = clWidth / 3;
				e.preventDefault();
				this.ismove = true;
				// this.moveX = e.touches[0].clientX;
				// this.moveY = e.touches[0].clientY;
				let moveEndX = e.changedTouches[0].pageX;
				this.X = moveEndX - this.startX
			},
			touchend(e) {
				e.preventDefault();
				let view = document.getElementById('reader-page-view');
				// let screenHeight =document.body.clientHeight;
				// let screenWidth =document.body.clientWidth;
				// let Wside = screenWidth/3;
				// let Hside = screenHeight/3;
			
				let touchCurrentX = e.changedTouches[0].pageX;
				let touchCurrentY = e.changedTouches[0].pageY;
				let clWidth = document.documentElement.clientWidth || document.body.clientWidth;
				let clHeight = document.documentElement.clientHeight || document.body.clientHeight;
				let touchoffsetY = clHeight / 3;
				let touchoffsetX = clWidth / 3;
				// console.log(view.scrollHeight);
				// console.log('页面的高度:'+view.clientHeight);
			
				if (!this.ismove) {
					// let touchPointX = e.changedTouches[0].pageX;
					// let touchPointY = e.changedTouches[0].pageY;
					if (touchoffsetX <= touchCurrentX && touchCurrentX <= touchoffsetX * 2 && touchoffsetY <=
						touchCurrentY &&
						touchCurrentY <= touchoffsetY * 2) {
						this.option = !this.option;
						if (this.option == true) {
							window.android.setTransparentHide(false)
							// $Android.setTransparentHide(false)
						} else if (this.option == false) {
							window.android.setTransparentHide(true)
							// $Android.setTransparentHide(true)
						}
						window.android.setBarcolor(true)
						// 明暗度
						if (this.background != '#000000') {
							this.show = false
						} else if (this.background == '#000000') {
							this.show = true
						}
						console.log(this.background, 'this.background ');
						return false;
					}
				}
				// alert(e, 'touchend')
				// this.startX - this.moveX <= 0 ? console.log('你在往右滑') : console.log('你在往左滑')
				if (touchCurrentX <= touchoffsetX) { //用户点击左侧三分之一
					if (this.last_chapter != null) {
			
						if (this.currentPaging === 1) { //当前页为第一页的时候
							this.bookContent = [];
							// Toast.loading({
							// 	message: '加载中...',
							// 	forbidClick: true,
							// });
							this.isClickPage = true;
							this.getPrevChapter('click');
							this.bookCurrentPage--;
						} else { //当前页为其他页面的时候
							this.currentPaging--;
							this.offsetX += (clWidth - this.margin);
							console.log(this.offsetX, 'this.offsetX')
			
							this.styleObject = {
								'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
								transitionDuration: this.transitionDuration
							};
							// console.log(this.styleObject, 'this.styleObject')
						}
					} else if (this.currentPaging === 1) {
						Toast('已经是第一章了！');
						return
					} else {
						this.currentPaging--;
						console.log(this.currentPaging)
						this.offsetX += (clWidth - this.margin);
						console.log(this.offsetX, 'this.offsetX')
			
						this.styleObject = {
							'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
							transitionDuration: this.transitionDuration
						};
					}
			
				}
				// else if (touchoffsetX <= touchCurrentX && touchCurrentX <= touchoffsetX * 2 && touchoffsetY <= touchCurrentY && touchCurrentY <= touchoffsetY * 2) {
				// 	this.option = !this.option;
				// 	// this.show = !this.show;
				// 	if (this.option == true) {
				// 		window.android.setTransparentHide(false)
				// 	} else if (this.option == false) {
				// 		window.android.setTransparentHide(true)
				// 	}
				// 	window.android.setBarcolor(true)
				// 	// 明暗度
				// 	if (this.background != '#000000') {
				// 		this.show = false
				// 	} else if (this.background == '#000000') {
				// 		this.show = true
				// 	}
				// 	console.log(this.background, 'this.background ');
				// 	return false;
				// } 
				else if (touchCurrentX >= touchoffsetX * 2 && touchCurrentX <= clWidth) { // 右滑触发
					this.isClickPage = false;
					if (this.next_chapter == null) {
						if (this.currentPaging === this.resultPaging) {
							Toast('已经是最后一章了！');
							return false;
						}
					}
					//翻页
					this.currentPaging++;
					console.log(this.resultPaging, this.currentPaging, 'this.resultPaging - this.currentPaging')
					if ((this.resultPaging - this.currentPaging) === -1) { //当前页为总页数的倒数第二页的时候加载下一章
						// this.currentPaging=1;
						this.bookContent = [];
						this.getNextChapter()
					}
					if (this.currentPaging === this.resultPaging + 1) { //当前页等于总页数的时候
						// Toast.loading({
						// 	message: '加载中...',
						// 	forbidClick: true,
						// });
						this.styleObject = '';
						this.offsetX = 0;
						this.getNextChapter('click');
						this.bookCurrentPage++;
						this.currentPaging = 1;
					} else { //当前页不等于总页数的时候
						this.offsetX -= (clWidth - this.margin);
						console.log(this.offsetX, 'this.offsetX')
						this.styleObject = {
							'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
							transitionDuration: this.transitionDuration
						};
						console.log(this.styleObject, 'this.styleObject')
					}
				}
			},
			ttsPageFunc(isEndPage) {
				let clWidth = document.documentElement.clientWidth || document.body.clientWidth;
				let clHeight = document.documentElement.clientHeight || document.body.clientHeight;
				this.isClickPage = false;
				if (this.next_chapter == null) {
					if (this.currentPaging === this.resultPaging) {
						Toast('已经是最后一章了！');
						return false;
					}
				}
				
				//翻页
				this.currentPaging++;
				console.log(this.resultPaging, this.currentPaging, 'this.resultPaging - this.currentPaging')
				
				// if (this.currentPaging === this.resultPaging) { //当前页为总页数的倒数第二页的时候加载下一章
				// 	// this.currentPaging=1;
				// 	// this.bookContent = [];
				// 	this.getNextChapter()
				// }
				if (this.currentPaging === this.resultPaging + 1) { //当前页等于总页数的时候
					// Toast.loading({
					// 	message: '加载中...',
					// 	forbidClick: true,
					// });
					
				} else { //当前页不等于总页数的时候
					this.offsetX -= (clWidth - this.margin);
					console.log(this.offsetX, 'this.offsetX')
					this.styleObject = {
						'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
						transitionDuration: this.transitionDuration
					};
					console.log(this.styleObject, 'this.styleObject')
				}
			},
			//左右滑动
			setRead(e) {
				// alert(e, 'setRead')
				// debugger;
				if (this.pagingPattern === 0) {
					this.option = !this.option
					return
				}
				let clWidth = document.documentElement.clientWidth || document.body.clientWidth;
				let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
				let currentX = e.pageX;
				let currentY = e.pageY;
				let offsetX = clWidth / 3;
				let offsetY = clientHeight / 3;
				if (currentX <= offsetX) { //用户点击左侧三分之一

					if (this.last_chapter != null) {

						if (this.currentPaging === 1) { //当前页为第一页的时候
							this.bookContent = [];
							// Toast.loading({
							// 	message: '加载中...',
							// 	forbidClick: true,
							// });
							this.isClickPage = true;
							this.getPrevChapter('click');
							this.bookCurrentPage--;
						} else { //当前页为其他页面的时候
							this.currentPaging--;
							this.offsetX += (clWidth - this.margin);
							console.log(this.offsetX, 'this.offsetX')

							this.styleObject = {
								'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
								transitionDuration: this.transitionDuration
							};
							// console.log(this.styleObject, 'this.styleObject')
						}
					} else if (this.currentPaging === 1) {
						Toast('已经是第一章了！');
						return
					} else {
						this.currentPaging--;
						console.log(this.currentPaging)
						this.offsetX += (clWidth - this.margin);
						console.log(this.offsetX, 'this.offsetX')

						this.styleObject = {
							'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
							transitionDuration: this.transitionDuration
						};
					}


				} else if (offsetX <= currentX && currentX <= offsetX * 2 && offsetY <= currentY && currentY <= offsetY *
					2) { //点击中间三分之一的时候
					this.option = !this.option;
					// this.show = !this.show;
					if (this.option == true) {
						window.android.setTransparentHide(false)
						// $Android.setTransparentHide(false)
					} else if (this.option == false) {
						window.android.setTransparentHide(true)
						// $Android.setTransparentHide(true)
					}
					window.android.setBarcolor(true)
					// 明暗度
					if (this.background != '#000000') {
						this.show = false
					} else if (this.background == '#000000') {
						this.show = true
					}
					console.log(this.background, 'this.background ')
				} else if (currentX >= offsetX * 2 && currentX <= clWidth) { //用户点击右侧三分之一
					this.isClickPage = false;
					if (this.next_chapter == null) {
						if (this.currentPaging === this.resultPaging) {
							Toast('已经是最后一章了！');
							return false;
						}
					}
					//翻页
					this.currentPaging++;
					console.log(this.resultPaging, this.currentPaging, 'this.resultPaging - this.currentPaging')
					if ((this.resultPaging - this.currentPaging) === -1) { //当前页为总页数的倒数第二页的时候加载下一章
						// this.currentPaging=1;
						this.bookContent = [];
						this.getNextChapter()

					}
					if (this.currentPaging === this.resultPaging + 1) { //当前页等于总页数的时候
						// Toast.loading({
						// 	message: '加载中...',
						// 	forbidClick: true,
						// });
						this.styleObject = '';
						this.offsetX = 0;
						this.getNextChapter('click');
						this.bookCurrentPage++;
						this.currentPaging = 1;
					} else { //当前页不等于总页数的时候
						this.offsetX -= (clWidth - this.margin);
						console.log(this.offsetX, 'this.offsetX')
						this.styleObject = {
							'-webkit-transform': 'translateX(' + this.offsetX + 'px' + ')',
							transitionDuration: this.transitionDuration
						};
						// console.log(this.styleObject, 'this.styleObject')
					}

				}
			},
			//下一章
			//字符串解析
			bookChaptersBody(books) {
				var reg = /<[^>]+>/g;
				console.log(books)
				if (reg.test(books) == false) {
					let c = /[\u4E00-\u9FA5\uF900-\uFA2D]/g;
					let _book = JSON.stringify(books).replace(/^"|"$/g, '');
					this.loading = false;
					if (c.test(_book)) {
						// .replace(/[\\n,\\r]/g &amp;nbsp; .replace(/&amp;nbsp/g, '')
						_book = '<p>' + _book.replace(/\s['===','——','&']*/g, '').replace(/&amp;nbsp/g, '').replace(
								/<h1>/g, '<p>').replace(
								/<h2>/g, '<p>').replace(/<h3>/g, '<p>').replace(/<h4>/g, '<p>').replace(/<h5>/g, '<p>')
							.replace(/<h6>/g, '<p>')
							.replace(/\n/g, '').replace(/[\\n]/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') +
							'</p>';
						return _book
					} else {
						return 'vip章节，请购买或者换源阅读！' //换源功能已经实现
					}
				} else {
					return books;
				}
			},

			//将书源和章节及页面缓存到LocalStorage
			setBookLocalStorage() {
				let localShelf = JSON.parse(window.localStorage.getItem('book')) ? JSON.parse(window.localStorage.getItem(
					'book')) : {};
				localShelf[this.$route.params.id].chapterIndexCache = this.bookCurrentPage;
				localShelf[this.$route.params.id].bookSource = this.BookSourcesId;
				localShelf[this.$route.params.id].pageIndexCache = this.currentPaging;
				window.localStorage.setItem('book', JSON.stringify(localShelf))
			},
			//获取上一章
			getPrevChapter(click) {
				this.chapter_id = this.last_chapter;
				if (this.$route.query.fileIdx == undefined) {
					this.$axios.post(`${this.$api.read}?chapter_id=${this.last_chapter}`).then(res => {
						this.readInfoData = res.data.data;
						if (this.readInfoData.type == 2) {
							this.sq_show = false;
						} else {
							this.sq_show = true;
						}
						if (res.data.data == null) {
							this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
							Toast(res.data.msg);
							return false
						} else if (res.data.code == 0) {
							this.readBookShow = false;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;

							this.vipBooks_name = res.data.data.books_name;
							this.vipNumber = res.data.data.number;
							this.vipTitle = res.data.data.title;
							this.vip_cost = res.data.data.vip_cost;
							this.vipUser_money = res.data.data.user_money;

						} else if (res.data.data.lock_id == 1 && res.data.data.lock_status == 0) {
							Toast('本章因敏感词问题被后台管理员锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
							return false;
						} else if (res.data.data.lock_id == 2 && res.data.data.lock_status == 0) {
							Toast('本章已被作者锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
							this.chapter_num = res.data.data.number;
							// this.readCacheList.push({chapter_id: this.chapter_id,chapter_num:this.chapter_num,booksId: this.bookId});

							// localStorage.setItem('readCacheList',JSON.stringify(this.readCacheList));
							return false;
						} else {
							this.readBookShow = true;
							this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content, res
								.data.data.number, res.data
								.data.books_name, res.data.data.location_status, res.data.data.narrate))
							this.dqpage = res.data.data.id;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
							this.chapter_num = res.data.data.number;

							//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
							var _t = this;
							setTimeout(function() {
								if (localStorage.getItem('lang')) {
									_t.$zh_tran(localStorage.getItem('lang'));
								}
							})
							//上一章 章节id
							_t.ds_chapterId = _t.last_chapter;
						}

					})
				}
			},

			//获取下一章
			getNextChapter(click) {
				this.chapter_id = this.next_chapter;
				if (this.$route.query.fileIdx == undefined) {
					this.$axios.post(`${this.$api.read}?chapter_id=${this.next_chapter}`).then(res => {
						this.readInfoData = res.data.data;
						if (this.readInfoData.type == 2) {
							this.sq_show = false;
						} else {
							this.sq_show = true;
						}
						if (res.data.data == null) {
							this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
							Toast(res.data.msg);
							return false
						} else if (res.data.code == 0) {
							this.readBookShow = false;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;

							this.vipBooks_name = res.data.data.books_name;
							this.vipNumber = res.data.data.number;
							this.vipTitle = res.data.data.title;
							this.vip_cost = res.data.data.vip_cost;
							this.vipUser_money = res.data.data.user_money;

						} else if (res.data.data.lock_id == 1 && res.data.data.lock_status == 0) {
							Toast('本章因敏感词问题被后台管理员锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;

							this.chapter_num = res.data.data.number;

							return false;
						} else if (res.data.data.lock_id == 2 && res.data.data.lock_status == 0) {
							Toast('本章已被作者锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;

							this.chapter_num = res.data.data.number;

							return false;
						} else {
							this.readBookShow = true;
							this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content, res.data.data.number, res.data.data.books_name, res.data.data.location_status, res.data.data.narrate))
							this.dqpage = res.data.data.id;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
							
							this.chapter_num = res.data.data.number;

							//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
							var _t = this;
							setTimeout(function() {
								if (localStorage.getItem('lang')) {
									_t.$zh_tran(localStorage.getItem('lang'));
								}
							})
							//下一章 章节id
							_t.ds_chapterId = _t.next_chapter - 1;
						}

					})
				}
			},
			//朗读获取下一章
			getTTSNextChapter() {
				this.chapter_id = this.next_chapter;
				if (this.$route.query.fileIdx == undefined) {
					this.$axios.post(`${this.$api.read}?chapter_id=${this.next_chapter}`).then(res => {
						this.readInfoData = res.data.data;
						if (this.readInfoData.type == 2) {
							this.sq_show = false;
						} else {
							this.sq_show = true;
						}
						if (res.data.data == null) {
							this.bookCacheContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
							Toast(res.data.msg);
							return false
						} else if (res.data.code == 0) {
							this.readBookShow = false;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
			
							this.vipBooks_name = res.data.data.books_name;
							this.vipNumber = res.data.data.number;
							this.vipTitle = res.data.data.title;
							this.vip_cost = res.data.data.vip_cost;
							this.vipUser_money = res.data.data.user_money;
			
						} else if (res.data.data.lock_id == 1 && res.data.data.lock_status == 0) {
							Toast('本章因敏感词问题被后台管理员锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
			
							this.chapter_num = res.data.data.number;
			
							return false;
						} else if (res.data.data.lock_id == 2 && res.data.data.lock_status == 0) {
							Toast('本章已被作者锁定')
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
			
							this.chapter_num = res.data.data.number;
			
							return false;
						} else {
							this.readBookShow = true;
							this.bookCacheContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content, res.data.data.number, res.data.data.books_name, res.data.data.location_status, res.data.data.narrate))
							this.dqpage = res.data.data.id;
							this.next_chapter = res.data.data.next_chapter;
							this.last_chapter = res.data.data.last_chapter;
							
							this.chapter_num = res.data.data.number;
			
							//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
							var _t = this;
							setTimeout(function() {
								if (localStorage.getItem('lang')) {
									_t.$zh_tran(localStorage.getItem('lang'));
								}
							})
							//下一章 章节id
							_t.ds_chapterId = _t.next_chapter - 1;
						}
			
					})
				}
			},
			//构建book类
			_nromalBook(title, content, number, books_name, location_status, narrate) {
				let book = {
					title: title,
					content: content,
					number: number,
					books_name: books_name,
					location_status: location_status,
					narrate: narrate,
					contentList: (content.replace(/&nbsp;/g, ' ').replace(/<p>|<\/p>|<br>/g, '\n').includes('\n')?content.replace(/&nbsp;/g, ' ').replace(/<p>|<\/p>|<br>/g, '\n').split('\n'):content.replace(/&nbsp;/g, ' ').replace(/<p>|<\/p>|<br>/g, '\n').split('\n')).filter(item => {return item !== null && item !== undefined && item.trim() !== '';})
				}
				console.log(book.contentList)
				return book
			},
			//无限加载
			loadMore() {
				this.loading = true;
				if (this.bookCurrentPage === this.bookSourceLinks.length) {
					return
				}
				this.moreLoading = true;
				this.bookCurrentPage++;
				setTimeout(() => {
					this.loading = false;
					this.moreLoading = false;
				}, 2500);
			},
			//上下章节切换
			nextChapter() {
				this.moreLoading = false;
				this.loading = true;
				// Toast.loading({
				// 	message: '加载中...',
				// 	forbidClick: true,
				// });
				this.bookContent = [];
				this.getNextChapter('click');
			},
			prevChapter() {
				this.bookContent = [];
				this.getPrevChapter('click');
			},
			convert(nOption) {},
			onChange(value) {
				// debugger;
				// localStorage.setItem('onChangeReadVal',this.slidervalue );
				// if(this.slidervalue > value && value <= 100 && this.last_chapter != null){
				// 	this.slidervalue = value;
				// 	console.log(this.changeSlideRead,this.slidervalue,'value');
				// 	this.bookContent=[];
				// 	this.getPrevChapter()
				// }
				// if(this.slidervalue <= value <= 100 && this.next_chapter != null){
				// 	this.slidervalue = value;
				// 	this.bookContent=[];
				// 	this.getNextChapter();
				// }

			},
			left_arr() {
				if (this.stepSet <= this.slidervalue <= 100 && this.last_chapter != null) {
					this.slidervalue -= Math.abs(this.stepSet);
					this.bookContent = [];
					this.getPrevChapter();
				} else if (this.last_chapter == null) {
					this.slidervalue = this.stepSet;
					Toast('已经是第一章了')
				}
			},
			right_arr() {
				if (this.stepSet <= this.slidervalue <= 100 && this.next_chapter != null) {
					this.slidervalue += Math.abs(this.stepSet);
					this.bookContent = [];
					this.getNextChapter();
				} else if (this.next_chapter == null) {
					this.slidervalue = 100;
					Toast('已经是最后一章了')
				}

			},
			setFn() {
				this.bgc_set_show = !this.bgc_set_show
			},
			slow_btnFn() {
				this.readvalue--;
			},
			fast_btnFn() {
				this.readvalue++;
				// console.log('000', this.readvalue)
			},


			navbarFn(data) {
				this.navBarIndex = data;
				// if(data == 1){
				// }
			},
			//获取详情页数据
			get_book_detail() {
				this.$axios.post(`${this.$api.book_detail}?book_id=${this.bookId}`).then(res => {
					if (res.status == 200) {
						this.book_details = res.data.data;
						this.book_details.chapter_list.forEach((item, i) => {
							item['soltNum'] = i + 1;
						})
						this.book_details.bookmark_list.forEach((item, i) => {
							item['soltNum'] = i + 1;
						})
						var sliderValRead = Math.floor(100 / this.book_details.chapter_list.length);
						this.stepSet = Math.abs(sliderValRead);
						this.slidervalue = Math.abs(sliderValRead) || 'NaN';
						this.book_comments = this.book_details.comment_list;
						for (var i = 0; i < this.book_comments.length; i++) {
							this.get_c_score.push({
								c_score: this.book_comments[i].c_score,
								chapter_num: this.book_comments[i].chapter_num
							})
						}
						if (this.book_details.is_collect == 1) {
							this.showSc = false;
						}
						// alert(this.slidervalue)
						// console.log(this.stepSet, this.slidervalue, 'this.stepSet--==')
						// console.log(this.book_details, 'book_details852');
					}
				})
			},
			jumpReadbook(id, books_id, lock_status, lock_id, is_vip, number) {
				this.activeid = id;
				this.chapter_id = id;
				this.chapter_num = number;
				this.get_book_detail();
				this.bookContent = [];
				this.books_id_jump = books_id;
				this.lock_status_jump = lock_status;
				this.lock_id_jump = lock_id;
				this.is_vip_jump = is_vip;
				this.listOption = !this.listOption; //弹窗消失
				if (this.$route.query.fileIdx == undefined) {
					if (lock_status == 0) { //管理员 && lock_id == 1
						// this.$axios.post(`${this.$api.read}?chapter_id=${id}`).then(res => {
						// 	if (res.data.data == null) {
						// 		this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
						// 		Toast(res.data.msg);
						// 		return false
						// 	} else if (res.data.code == 0) {
						// 		this.readBookShow = false;
						// 		this.next_chapter = res.data.data.next_chapter;
						// 		this.last_chapter = res.data.data.last_chapter;

						// 		this.vipBooks_name = res.data.data.books_name;
						// 		this.vipNumber = res.data.data.number;
						// 		this.vipTitle = res.data.data.title;
						// 		this.vip_cost = res.data.data.vip_cost;
						// 		this.vipUser_money = res.data.data.user_money;
						// 	} else {
						// 		this.readBookShow = true;
						// 		this.bookContent.push(this._nromalBook(res.data.data.title, res.data.data.content, res.data.data.number, res.data
						// 			.data.books_name, res.data.data.location_status, res.data.data.narrate))
						// 		this.dqpage = res.data.data.id;
						// 		this.next_chapter = res.data.data.next_chapter;
						// 		this.last_chapter = res.data.data.last_chapter;
						// 		console.log(this.bookContent, 'this.bookContent 019')

						// 		//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
						// 		var _t = this;
						// 		setTimeout(function() {
						// 			if (localStorage.getItem('lang')) {
						// 				_t.$zh_tran(localStorage.getItem('lang'));
						// 			}
						// 		})
						// 		//章节id
						// 		_t.ds_chapterId = id;
						// 	}

						// })
						Toast('本章因敏感词问题被后台管理员锁定');
						return false;
					} else if (lock_status == 2 && this.user_id != this.book_details.user_id && this.user_id !=
						'') { //&& lock_id == 2
						Toast('该章节已被作者自行锁定');
						return false;
					} else if (lock_status == 2 && this.user_id == this.book_details.user_id && this.user_id !=
						'') { //作者自己&& lock_id == 2
						this.$axios.post(`${this.$api.read}?chapter_id=${id}`).then(res => {
							this.readInfoData = res.data.data;
							if (this.readInfoData.type == 2) {
								this.sq_show = false;
							} else {
								this.sq_show = true;
							}
							if (res.data.data == null) {
								this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
								Toast(res.data.msg);
								return false
							} else if (res.data.code == 0) {
								this.readBookShow = false;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;

								this.vipBooks_name = res.data.data.books_name;
								this.vipNumber = res.data.data.number;
								this.vipTitle = res.data.data.title;
								this.vip_cost = res.data.data.vip_cost;
								this.vipUser_money = res.data.data.user_money;
								this.chapter_num = res.data.data.number;
							} else {
								this.readBookShow = true;
								this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content,
										res.data.data.number, res.data
										.data.books_name, res.data.data.location_status, res.data.data.narrate
										))
								this.dqpage = res.data.data.id;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;
								console.log(this.bookContent, 'this.bookContent 019')
								//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
								var _t = this;
								// setTimeout(function() {
								// 	if (localStorage.getItem('lang')) {
								// 		_t.$zh_tran(localStorage.getItem('lang'));
								// 	}
								// })
								//章节id
								_t.ds_chapterId = id;
							}

						})
					} else if (lock_status == 1) { //lock_status != 0
						this.$axios.post(`${this.$api.read}?chapter_id=${id}`).then(res => {
							this.readInfoData = res.data.data;
							if (this.readInfoData.type == 2) {
								this.sq_show = false;
							} else {
								this.sq_show = true;
							}
							if (res.data.data == null) {
								this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
								Toast(res.data.msg);
								return false
							} else if (res.data.code == 0) {
								this.readBookShow = false;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;

								this.vipBooks_name = res.data.data.books_name;
								this.vipNumber = res.data.data.number;
								this.vipTitle = res.data.data.title;
								this.vip_cost = res.data.data.vip_cost;
								this.vipUser_money = res.data.data.user_money;
								this.chapter_num = res.data.data.number;
							} else {
								this.readBookShow = true;
								this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content,
										res.data.data.number, res.data
										.data.books_name, res.data.data.location_status, res.data.data.narrate
										))
								this.dqpage = res.data.data.id;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;
								this.chapter_num = res.data.data.number;
								//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
								var _t = this;
								// setTimeout(function() {
								// 	if (localStorage.getItem('lang')) {
								// 		_t.$zh_tran(localStorage.getItem('lang'));
								// 	}
								// })
								//章节id
								_t.ds_chapterId = id;
							}

						})
					} else if (lock_status == 1 && is_vip == 2) { //lock_id != 1 && lock_id != 2
						// if (is_vip == 2) {//is_vip == 2 && lock_status != 0
						this.$axios.post(`${this.$api.read}?chapter_id=${id}`).then(res => {
							this.readInfoData = res.data.data;
							if (this.readInfoData.type == 2) {
								this.sq_show = false;
							} else {
								this.sq_show = true;
							}
							if (res.data.data == null) {
								this.bookContent.push(this._nromalBook('', '该篇为vip文章', 0, ''))
								Toast(res.data.msg);
								return false
							} else if (res.data.code == 0) {
								this.readBookShow = false;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;

								this.vipBooks_name = res.data.data.books_name;
								this.vipNumber = res.data.data.number;
								this.vipTitle = res.data.data.title;
								this.vip_cost = res.data.data.vip_cost;
								this.vipUser_money = res.data.data.user_money;
								this.chapter_num = res.data.data.number;
							} else {
								this.readBookShow = true;
								this.bookContent.push(this._nromalBook(res.data.data.title, typeof res.data.data.content === 'string'?res.data.data.content.replace('/\n\n/g', '\n'):res.data.data.content,
									res.data.data.number, res
									.data.data.books_name, res.data.data.location_status, res.data.data
									.narrate))
								this.dqpage = res.data.data.id;
								this.next_chapter = res.data.data.next_chapter;
								this.last_chapter = res.data.data.last_chapter;
								this.chapter_num = res.data.data.number;
								//初始化文字是简体还是繁体（localStorage是有存在lang，s简体，t繁体）
								var _t = this;
								setTimeout(function() {
									if (localStorage.getItem('lang')) {
										_t.$zh_tran(localStorage.getItem('lang'));
									}
								})
								//章节id
								_t.ds_chapterId = id;
							}

						})
						// } 
					}
				}
			},
			allMFzjFn() {
				this.allMFzj = !this.allMFzj;
				this.scrollable = true;
				if (this.allMFzj) {
					this.leftnavText = '收起';
				} else {
					this.leftnavText = '查看全部';
				}
			},
			soltFn() {
				this.solt_reverse = !this.solt_reverse;
				this.book_details.chapter_list.reverse()
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) +
					" " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(),
					2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			onSwitchLanguage(val) { //简繁体切换
				this.lang = val;
				if (val == 's') {
					localStorage.setItem('lang', 't');
					this.isTraditional = false;
				} else {
					localStorage.setItem('lang', 's');
					this.isTraditional = true;
				}
				this.$zh_tran(localStorage.getItem('lang'));
			},
			lockOrients() { //横竖屏切换
				localStorage.setItem('isLlock', false);
				this.isLlock = false;
				if (this.$webapp.isAndroid) {
					console.log("安卓") //获取亮度 --- 安卓
					window.android.setorientation(0); //横屏
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
				// plus.screen.lockOrientation("landscape-primary");
			},
			unlockOrients() { //解除锁定屏幕方向
				localStorage.setItem('isLlock', true);
				this.isLlock = true;
				// plus.screen.lockOrientation("portrait-primary");
				if (this.$webapp.isAndroid) {
					console.log("安卓") //获取亮度 --- 安卓
					window.android.setorientation(1); //竖屏
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
			},
			// 打赏
			givegifts() {
				this.tostShowBox = true;
			},
			onMask() {
				this.tostShowBox = false;
			},
			toggle() {
				if (this.selectItem) {
					this.selectItem = false;
				} else {
					this.selectItem = true;
				}

			},
			query_select(index, txt) {
				console.log(index)
				this.queryIndex = index;
				this.queryTitle = txt;
				this.c_score = txt;

				// alert(this.c_score)
				this.selectItem = !this.selectItem
			},
			itemyunjinbiFn(data, txt, num) {
				this.itemyunjinbi = data;
				if (this.itemyunjinbi == 0) {
					this.ds_value = "黑夜给了我黑色的眼睛，我却用来寻找流星~"
				} else if (this.itemyunjinbi == 1) {
					this.ds_value = "百年树人，十年树木，五年造卫星~"
				} else if (this.itemyunjinbi == 2) {
					this.ds_value = "千里之行，始于足下；万里星空，有辣么一颗小行星~"
				} else if (this.itemyunjinbi == 3) {
					this.ds_value = "苟有恒，不必三更起五更眠又有黑眼圈~"
				} else if (this.itemyunjinbi == 4) {
					this.ds_value = "盛年不重来，彗星难在寻"
				} else if (this.itemyunjinbi == 5) {
					this.ds_value = "逝者如斯夫，不舍星云"
				} else if (this.itemyunjinbi == 6) {
					this.ds_value = "不积跬步，无以至千里；不积小流，无以成银河~"
				} else if (this.itemyunjinbi == 7) {
					this.ds_value = '人间精品快乐汽水，九霄瑶池琼浆玉露'
				}
				if (txt == '琼浆玉露') {
					this.coin = ''
				} else {
					this.coin = txt
				}

				this.gift = num
			},

			// 打赏排行榜
			go_fairies() {
				this.$router.push({
					path: '/morexiaoxianv',
					query: {
						book_id: this.bookId,
					}
				})
			},
			// 确认打赏
			add_comment() {
				var _t = this;
				let comment = {};
				if (_t.get_c_score.length != 0) {
					for (var i = 0; i < _t.get_c_score.length; i++) {
						if (_t.get_c_score[i].chapter_num == _t.chapter_num) {
							if (_t.get_c_score[i].c_score == _t.c_score) {
								_t.c_score = 0;
							} else if (_t.get_c_score[i].c_score != _t.c_score) {
								comment = {
									chapter_id: _t.ds_chapterId,
									book_id: _t.ds_bookId,
									coin: _t.coin,
									gift: _t.gift,
									content: _t.ds_value,
									score: _t.c_score,
									nickName: _t.userInfoUsername,
								}
							}
						} else {
							comment = {
								chapter_id: _t.ds_chapterId,
								book_id: _t.ds_bookId,
								coin: _t.coin,
								gift: _t.gift,
								content: _t.ds_value,
								score: _t.c_score,
								nickName: _t.userInfoUsername,
							}

						}
					}
				} else {
					comment = {
						chapter_id: _t.ds_chapterId,
						book_id: _t.ds_bookId,
						coin: _t.coin,
						gift: _t.gift,
						content: _t.ds_value,
						score: _t.c_score,
						nickName: _t.userInfoUsername,
					}
				}

				if (!_t.ds_value) {
					Toast('评论必填！');
				} else if (JSON.parse(localStorage.getItem('userInfoData')) == undefined) {
					Toast('请登录后操作');
					return false;
				} else {
					_t.$axios.post(_t.$api.book_comment + '?' + qs.stringify(comment)).then(res => {
						if (res.data.code == 1) {
							Toast(res.data.msg);

							_t.itemyunjinbi = -1;
							_t.ds_value = '';
							_t.queryIndex = '';
							_t.coin = '';
							_t.gift = '';
							_t.c_score = '';
							_t.queryTitle = '2';

							_t.tostShowBox = false;
						} else {
							if (res.data.msg == '余额不足') {
								Toast('您的余额不足请到我的-云锦币充值进行充值后操作')
							} else {
								Toast(res.data.msg);
							}
						}
					})
				}

			},
		},
		watch: {
			bookContent(newVal, oldVla) {
				// console.log(this.$refs.wrapper,this.$refs.wrapper.scrollTop,'this.$refs.wrapper-----------------')
				// this.$refs.wrapper.scrollTop = 0;
				var _this = this;
				// setTimeout(function() {
				if (_this.pagingPattern === 1) {
					_this.$nextTick(function() {
						if (_this.$refs.bookInner != undefined) {
							for (var i = 0; i < _this.$refs.bookInner.length; i++) {
								let scrollW = _this.$refs.bookInner[0].scrollWidth;
								let clientW = _this.$refs.bookInner[0].clientWidth;
								_this.resultPaging = Math.floor(scrollW / clientW);
								// alert(scrollW+'----0-----'+clientW +'----0-----'+ _this.resultPaging);
							}
						}

						if (_this.isClickPage) {
							_this.currentPaging = _this.resultPaging;
							_this.offsetX = -(_this.currentPaging - 1) * (_this.clWidth - _this.margin);
							_this.styleObject = {
								'-webkit-transform': 'translateX(' + _this.offsetX + 'px' + ')',
								transitionDuration: '0s'
							};
						}
					});
				}
				// }, 300)

			},
			// $route(to) {
			// 	this.$nextTick(() => {
			// 		this.$zh_tran(localStorage.getItem('lang'))
			// 	})

			// }
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>
<style>
	/* // 兼容多个浏览器 */
	pre {
		white-space: pre-wrap;
		white-space: -moz-pre-wrap;
		white-space: -pre-wrap;
		white-space: -o-pre-wrap;
		*word-wrap: break-word;
		*white-space: normal;
		letter-spacing: 4px;
	}

	.van-dialog__confirm,
	.van-dialog__confirm:active {
		color: #ff4081;
	}

	.van-slider--disabled {
		opacity: 1;
	}
</style>
<style scoped lang="less" rel="stylesheet/less">
	// /deep/ h1,
	// /deep/ h2,
	// /deep/ h3,
	// /deep/ h4,
	// /deep/ h5,
	// /deep/ h6,{
	// 	font-weight: normal;
	// 	font-size: 48px !important;
	// }
	.fixedBox {
		position: fixed;
		bottom: 15px;
		left: 70px;
		color: #fff !important;
		font-size: 22px;

		/*px*/
		.wrapper {
			position: fixed;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			background-color: #132133;

			// color: '#ffffff',
			// background: 'rgba(238,169,169,1)'
			background: -webkit-radial-gradient(center circle, #132133 10%, rgba(7, 33, 39, 0.93) 85%);
			background: radial-gradient(circle at center, #132133 10%, rgba(7, 33, 39, 0.93) 85%);
		}

		.outer {
			display: table;
			height: 100%;
			width: 100%;
		}

		.inner {
			position: fixed;
			bottom: 8px;
			/*no*/
			left: 20px;
		}

		.battery {
			position: relative;
			display: inline-block;
			height: 0px;
			width: 20px;
			padding: 6px 5px;
			background-color: transparent;
			border: 2px solid rgba(112, 116, 108, 1);
			border-radius: 2px;
		}

		.battery:before {
			content: "";
			position: absolute;
			background-color: transparent;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border-radius: 5px;
			// box-shadow: inset 0 0 22px -5px rgba(194, 254, 225, 0.58);
		}

		.battery:after {
			content: "";
			position: absolute;
			top: calc(50% - 3.5px);
			right: -8px;
			height: 6px;
			width: 6px;
			background-color: #736a68;
		}

		.power {
			background-color: white;
			display: block;
			position: absolute;
			top: 0px;
			left: 0px;
			bottom: 4px;
			right: 10px;
			height: 12px;
			border-radius: 5px;
			-webkit-transform: scaleX(0.5);
			transform: scaleX(0.5);
			-webkit-transform-origin: 0 0;
			transform-origin: 0 0;
			background: rgba(111, 109, 107, 1);
			-webkit-transition: -webkit-transform 1s cubic-bezier(0, 0, 0.28, 0.95);
			transition: -webkit-transform 1s cubic-bezier(0, 0, 0.28, 0.95);
			transition: transform 1s cubic-bezier(0, 0, 0.28, 0.95);
			transition: transform 1s cubic-bezier(0, 0, 0.28, 0.95), -webkit-transform 1s cubic-bezier(0, 0, 0.28, 0.95);
			max-width: 60px;
			overflow: hidden;
		}
	}

	.book {
		background: #f4f5e2;
		width: 100%;
		height: 100vh;
		// overflow-y: scroll;
		margin-top: -1px;
		position: relative;
		// color: #5c5d58 !important;

		.bootPage {
			position: fixed;
			top: 0;
			bottom: 0;
			width: 100%;
			background: rgba(244, 245, 246, 0.9);
			z-index: 10000;
			display: flex;
			max-width: 750px;

			.b-item {
				width: 33.3333333%;

				.center {
					padding: 20px;
					line-height: 100vh;
					width: 100%;
					font-size: 25px;
					color: #d0d0d0;
					box-sizing: border-box;
				}
			}

			.bootPage-center {
				border-left: 1px solid #5c5c5c;
				border-right: 1px solid #5c5c5c;
			}
		}

		.books-con {
			width: 100%;

			.book-content {
				padding: 50px 10px 80px 10px;

				/*no*/
				.book-inner {
					text-align: justify;
					line-height: 40px;
					/*no*/
					text-indent: 2em;
				}

				.book-title {
					line-height: 50px;
					font-weight: normal;
					margin-bottom: 30px;
				}

				.narrate_txt {
					line-height: 50px;
					font-weight: normal;
					margin-bottom: 30px;

					p:last-of-type {
						border-bottom: 2px dashed #f0f0f0;
					}
				}
			}
		}

		.loadMore {
			height: 80px;
			line-height: 80px;
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
		}

		.read-content {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;

			.read-article {
				position: absolute;
				overflow: hidden;
				padding: 0 10px;
				/*no*/
				text-align: justify;
				bottom: 20px;
				/*no*/
				top: 50px;
				/*no*/

				.read-section {
					height: 100%;

					font-weight: normal;

					.read-section-inner {
						overflow: visible;
						height: 100%;


						.book-inner {
							line-height: 60px;
							/*no*/
							text-indent: 2em;


							.book-title {
								// line-height:100px;
								font-weight: normal;
								margin-top: 20px;
								margin-bottom: 80px;
							}

							/deep/ * {
								font-weight: normal;
							}

							/deep/ p {
								/deep/ h1 {
									font-weight: normal;
								}
							}

							/deep/i,
							/deep/ c {
								display: block;
								border-top: 1px dashed #000;
								/*no*/
								text-align: left;
								text-indent: 0;
								font-style: normal;
							}

							/deep/ c {
								border-top: 0;
							}
						}

						.book-inner.book-innerTopTxt {
							/deep/p:first-of-type {
								border-bottom: 1px dashed #000;
								/*no*/
							}
						}
					}
				}
			}

			.book-title01 {
				position: fixed;
				// top: 60px;
				top: 10px;
				/*no*/
				width: 100vw;

				div {
					width: calc(50% - 20px);
					float: left;
				}

				div:first-child {
					padding-left: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				div:last-child {
					text-align: right;
					padding-right: 20px;

					span:first-child {
						padding-right: 20px;
					}
				}
			}

			.read-article {
				position: absolute;
				overflow: hidden;
				padding: 0 10px;
				/*no*/
				text-align: justify;
				bottom: 40px;
				/*no*/
				// top: 60px;/*no*/
				top: 50px;

				/*no*/
				.read-section {
					height: 100%;
					// padding-top: 150px;
					font-weight: normal;
					position: relative;

					.read-section-inner {
						overflow: visible;
						// height: calc(100% - 60px);
						height: 100%;

						.book-inner {
							line-height: 3;
							/*no*/
							text-indent: 2em;
						}
					}

					.book-title {
						// position: absolute;
						// top: 30px;
						// left: 4px;
						// font-weight: 400;
						// line-height: 100px;
						font-weight: normal;
						margin-top: 20px;
						margin-bottom: 80px;
					}

					.narrate_txt {
						font-weight: normal;
						margin-bottom: 30px;

						p:last-of-type {
							border-bottom: 2px dashed #f0f0f0;
						}

						position: absolute;
						top: 50px;
						width: 100%;
					}
				}
			}

			.article-page {
				color: #fff;
				font-size: 22px;
				/*px*/
				position: absolute;
				right: 10px;
				bottom: 15px
			}
		}
	}

	//收藏
	.van-popup--center {
		border-radius: 15px;

		.scBox {
			width: 70vw;
			height: 220px;
			text-align: center;
			margin: 0 auto;
			position: relative;

			p {
				line-height: 80px;
				font-size: 26px;
				/*px*/
			}

			/deep/.van-radio-group {
				margin-left: 21vw;

				/deep/.van-radio__icon .van-icon {
					width: 30px;
					height: 30px;
					line-height: 30px;
					font-size: 24px;
				}

				/deep/.van-radio__label {
					font-size: 22px;
					/*px*/
				}
			}

			.btn_box {
				position: absolute;
				bottom: 0;
				left: 0;
				background-color: #fff;
				text-align: center;
				display: flex;
				width: 70vw;
				line-height: 80px;
				border-top: 1px solid #f0f0f0;
				/*no*/
				font-size: 30px;
				/*px*/
				color: #000 !important;

				span:first-of-type {
					flex: 1;
					border-right: 1px solid #f0f0f0;
					/*no*/
				}

				span:last-of-type {
					flex: 1;
				}

				.active {
					color: #ff4081;
				}
			}
		}
	}

	.page-read-option {
		position: fixed;
		z-index: 888;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		visibility: hidden;

		.bgcSet {
			position: fixed;
			bottom: 20%;
			left: 40px;

			div {
				text-align: center;

				img.son {
					width: 60px;
					transition: all 0.5s ease;
				}

				img.night {
					width: 50px;
					transition: all 0.5s ease;
				}
			}
		}

		// 头部
		.headerBox {
			height: 160px;
			background-color: rgba(255, 255, 255, .9);
			display: flex;

			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;

				.arrImg {
					img {
						width: 60px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: right;
					font-size: 34px;

					/*px*/
					img {
						width: 40px;
						padding-top: 20px;
						margin-left: 16px;
					}
				}
			}

		}

		.book-header {
			line-height: 80px;
			height: 80px;
			background-color: rgba(255, 255, 255, .9);
		}

		.bottom-controll-bar {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			text-align: center;
			font-size: 0;

			.mint-button {
				width: 33.33333%;
				line-height: 80px;
				height: 80px;
				color: #fff;
				background: rgba(50, 51, 52, 0.9);
				border-radius: 0;
				font-size: 28px;
			}

			.add_my {
				position: absolute;
				bottom: 200px;
				right: 0;
				width: 150px;
				height: 60px;
				line-height: 60px;
				border-radius: 50px 0 0 50px;
			}

			//设置
			.footer_fixedBox {
				.footer_setBox {
					position: absolute;
					bottom: 0;
					width: 100vw;
					z-index: 888;
					background-color: rgba(255, 255, 255, .9);

					.footer_topBox {

						height: 60px;
						position: relative;

						.leftArr {
							position: absolute;
							top: 50%;
							left: 0px;
							transform: translateY(-50%);
						}

						.rightArr {
							position: absolute;
							top: 50%;
							right: 0px;
							transform: translateY(-50%) rotate(180deg);
						}

						.sliderBox {
							height: 60px;
							width: 80vw;
							position: relative;

							.van-slider {
								display: inline-block;
								width: 80vw;
								position: absolute;
								top: 50%;
								left: 12%;
								background-color: #dbdbdb;

								/deep/.van-slider__bar {
									width: 80vw;

									/deep/.van-slider__button {
										background-color: transparent;
										background: url(../../assets/img/myicon/readJd.png) no-repeat 50% 50%;
										background-size: 25px;
										box-shadow: 0 1px 2px rgba(0, 0, 0, 0);
									}
								}
							}

						}
					}

					.slidervalue {
						height: 50px;
						line-height: 50px;
						text-align: center;
						color: #3d3d3d;
						margin-bottom: 10px;
						font-size: 28px;
						/*px*/
					}

					.navBarBtn {
						display: flex;
						padding-bottom: 20px;

						div {
							flex: 1;
							text-align: center;

							img {
								width: 60px;
								vertical-align: middle;
								margin-bottom: 10px;
							}
						}

						div:first-of-type {
							img {
								padding-top: 15px;
								width: 40px;
							}
						}
					}

				}


			}


			.readSet {
				width: 100%;
				color: #fff;
				font-size: 28px;
				background: rgba(50, 51, 52, 0.9);
				padding: 20px;
				box-sizing: border-box;

				.readSet-item {
					height: 80px;

					span {
						text-align: center;
						display: inline-block;
						line-height: 60px;
						width: 200px;
						border-radius: 5px;
						border: 1px solid #535353;

						&.active {
							border: 1px solid #409eff;
						}
					}
				}

				.pattern {
					span:nth-of-type(2) {
						margin: 0 10px;
					}
				}
			}
		}

		.addReader {
			width: 25%;
			position: absolute;
			line-height: 60px;
			height: 60px;
			background: rgba(50, 51, 52, .9);
			color: #fff;
			text-align: center;
			border-radius: 10px;
			right: 0;
			top: 100px;
		}

	}

	.show-panel {
		visibility: visible;
	}

	.chapter-list {
		position: fixed;
		z-index: 999;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background: transparent;

		.list-content {
			width: 80%;
			height: 100%;
			background: #fff;
			position: absolute;

			.top-bar {
				position: absolute;
				width: 100%;
				height: 120px;
				line-height: 120px;
				font-size: 25px;
				font-weight: normal;
				padding-left: 20px;
				border-bottom: 1px solid #ebebeb;
				box-sizing: border-box;
				z-index: 100;
				background: #fff;
			}

			.chapter-con {
				position: absolute;
				top: 0;
				width: 100%;
				height: 100vh;
				margin-top: 120px;
				padding-left: 20px;
				box-sizing: border-box;
				overflow-y: scroll;

				.chapterList {
					width: 100%;

					div {
						line-height: 80px;
						height: 80px;
						font-size: 23px;
						color: #999;
						border-bottom: 1px solid #ebebeb;

						&.current {
							color: #409EFF;
						}
					}
				}
			}

		}

		.right {
			width: 100%;
			height: 80px;
			text-align: right;
		}
	}

	.changeSource {
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;
		background-color: rgba(50, 51, 52, 0.8);

		.source-content {
			width: 500px;
			height: 800px;
			background: #fff;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-left: -250px;
			margin-top: -400px;
			border-radius: 15px;
			padding: 20px;
			box-sizing: border-box;
			overflow-y: scroll;

			.source-item {
				line-height: 50px;
				font-size: 25px;
				position: relative;

				.center {
					width: 80%;
					font-size: 20px;
					color: #999;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.select {
					position: absolute;
					right: 0;
					top: 20px;
					background: #c9c9c9;
					padding: 0 10px;
					border-radius: 15px;
					display: none;
					color: #fff;
					font-size: 18px;
				}

				.active {
					display: block;
				}
			}
		}


		.change_source_btn {
			width: 200px;
			height: 80px;
			text-align: center;
			line-height: 80px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-top: -80px;
			margin-left: -100px;
			z-index: 1000;

			.source_btn {
				width: 100%;
				height: 100%;
				font-size: 25px;
			}
		}
	}

	//字号
	.font_color_fatherBox {
		// position: fixed;
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
	}

	.font_color_box {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		background-color: rgba(255, 255, 255, .9);
		padding: 20px 0;
		z-index: 889;
		color: #000;

		.bgc_ld {
			height: 60px;
			position: relative;

			.sliderBox {
				height: 60px;
				width: 75vw;
				display: inline-block;
				position: relative;
				margin-left: 10px;

				.van-slider {
					display: inline-block;
					width: 75vw;
					margin-left: 2vw;
					position: absolute;
					top: 50%;

					/deep/.van-slider__bar {
						width: 75vw;

						/deep/.van-slider__button {
							background-color: transparent;
							background: url(../../assets/img/myicon/ldicon.png) no-repeat 50% 50%;
							background-size: 50px;
							box-shadow: 0 1px 2px rgba(0, 0, 0, 0);
						}
					}
				}

			}

			span {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				right: 16px;
				font-size: 32px;
				/*px*/
			}
		}

		.bgc_seleBox {
			width: calc(100vw - 32px);
			height: 40px;
			overflow-x: scroll;
			padding: 20px 16px;

			.bgc_seleBox_child {
				width: 350vw;
			}

			span {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				float: left;
				margin-right: 40px;
			}

			// span:first-child,
			// 	{
			// 	background-color: #f9d088;
			// }

			// span:nth-child(2) {
			// 	background-color: #96cdba;
			// }

			// span:nth-child(3) {
			// 	background-color: #7f8ac6;
			// }

			// span:nth-child(4) {
			// 	background-color: #cae3a3;
			// }

			// span:nth-child(5) {
			// 	background-color: #f8abc1;
			// }

			// span:nth-child(6) {
			// 	background-color: #3f473c;
			// }

			// span:nth-child(7) {
			// 	background-color: #2a2722;
			// }

			// span:nth-child(8) {
			// 	background-color: #22312c;
			// }

			// span:nth-child(9) {
			// 	background-color: #17232f;
			// }

			// span:nth-child(10) {
			// 	background-color: #453d3b;
			// }

			// span:nth-child(11) {
			// 	background-color: #433b46;
			// }

			// span:nth-child(12) {
			// 	background-color: #121413;
			// }
		}

		.set_font {
			display: flex;
			justify-content: space-between;
			padding: 20px 16px;
			border: 1px solid #f0f0f0;

			/*no*/
			.fontsize_min {
				width: 200px;
				position: relative;
				display: flex;
				border: 1px solid #fa7298;
				/*no*/
				text-align: center;
				border-radius: 30px;

				span {
					flex: 1;
					color: #000;
					font-size: 28px;
					/*px*/
					height: 60px;
					line-height: 60px;
					color: #ff4081;
				}

				span:first-child {
					font-size: 40px;
					/*px*/
				}

				span:last-child {
					font-size: 40px;
					/*px*/
				}

				// .van-stepper {
				// 	background-color: #fff;
				// 	border: 1px solid #fa7298;
				// 	/*no*/
				// 	border-radius: 28px;

				// 	/*no*/
				// 	/deep/.van-stepper__minus,
				// 	/deep/.van-stepper__input,
				// 	/deep/.van-stepper__plus {
				// 		background-color: transparent;

				// 		&::before {
				// 			background-color: #ff4081;
				// 		}

				// 		&::after {
				// 			background-color: #ff4081;
				// 		}
				// 	}
				// }

				// span:last-child {
				// 	position: absolute;
				// 	top: 50%;
				// 	left: 50%;
				// 	transform: translate(-50%, -50%);
				// 	background-color: #fff;
				// 	color: #ff4081;
				// }
			}
		}

		.moreSet_box {
			display: flex;
			padding: 0px 16px;
			text-align: center;

			div {
				flex: 1;

				img {
					width: 60px;
				}

				p {
					font-size: 30px;
					/*px*/
				}
			}
		}
	}

	//朗读
	.toast_father_setBox {
		// position: fixed;
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;

		.toast_setBox {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			background-color: rgba(255, 255, 255, .9);
			padding: 20px 30px;
			width: calc(100vw - 60px);
			z-index: 888;

			.toast_top_setBox {
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				padding-bottom: 20px;
				height: 80px;
				position: relative;

				.ml_box {
					text-align: center;

					img {
						width: 50px;
					}

				}

				.singsong_set {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);

					img {
						width: 50px;
						padding-right: 80px;
					}

					img:last-child {
						padding-right: 0;
					}
				}

				.time_box {
					text-align: center;

					img {
						width: 40px;
					}
				}
			}

			.footer_topBox {
				height: 60px;
				width: calc(100vw - 60px);
				position: relative;
				display: flex;

				span.slow {
					position: absolute;
					top: 50%;
					left: 0px;
					transform: translateY(-50%);
				}

				span.fast {
					position: absolute;
					top: 50%;
					right: 0px;
					transform: translateY(-50%);
				}

				.sliderBox {
					height: 60px;
					flex: 1;
					position: relative;

					.van-slider {
						display: inline-block;
						width: 80vw;
						margin-left: 6vw;
						position: absolute;
						top: 50%;

						/deep/.van-slider__bar {
							width: 80vw;

							/deep/.van-slider__button {
								background-color: transparent;
								box-shadow: 0 1px 2px rgba(0, 0, 0, 0);
							}
						}
					}

				}
			}

			p {
				line-height: 50px;
			}

			.readingMode {
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				padding: 20px 0;

				button {
					border: 1px solid #FF4081;
					/*no*/
					height: 40px;
					/*px*/
					line-height: 40px;
					/*px*/
					border-radius: 40px;
					/*px*/
					color: #FF4081;
					background-color: #fff;
					padding: 0px 20px;
					margin-right: 20px;
				}
			}

			.quitReading {
				text-align: center;
				height: 60px;
				/*px*/
				padding: 20px 0 30px;
				display: flex;

				.quitReading_left {
					flex: 1;
					position: relative;

					img {
						width: 50px;
						/*px*/
						position: absolute;
						right: 0;
						top: 50%;
						transform: translateY(-50%);
					}
				}

				.quitReading_right {
					flex: 1;
					text-align: left;

					p {
						line-height: 60px;
						/*px*/
						font-size: 32px;
						/*px*/
						color: #4c4c4c;
						padding-left: 20px;
					}
				}
			}
		}
	}

	//目录弹窗
	.mlBox {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 1010;
		transition: all 1000ms linear 500ms;
		display: flex;
		background-color: transparent;

		.ml_infoBox {
			width: 85vw;
			background-color: #fff;
			height: 100vh;
			overflow: hidden;
			z-index: 100;

			//导航
			.ml_top.navBar {
				width: 85vw;
				position: fixed;
				top: 0px;
				left: 0;
				background-color: #fff;
				height: 120px;
				margin-bottom: 10px;
				z-index: 100;

				.ml_tab.navBarBox {
					padding: 0 20%;
					display: flex;
					position: relative;
					padding-top: 60px;
					font-size: 32px;

					/*px*/
					.tab_item {
						flex: 1;
						position: relative;

						span {
							width: 100%;
							text-align: center;
							line-height: 60px;
							display: inline-block;
							color: #3d3d3d;
							font-size: 32px;
							/*px*/
						}

						p {
							width: 30%;
							height: 4px;
							position: absolute;
							bottom: 0px;
							left: 50%;
							transform: translateX(-50%);
							background-color: transparent;
							border-radius: 4px;
						}
					}

					.tab_item.active {
						p {
							background-color: #fa7298;
						}

						span {
							// color: #fa7298;
							color: #404040;
							font-weight: normal;
						}
					}

					.ml_solt {
						img {
							position: absolute;
							top: 65px;
							right: 10px;
							width: 50px;
						}
					}
				}

			}

			.ml_body {
				margin-top: 160px;
				height: calc(100vh - 320px);
				overflow-y: scroll;
				color: #000;
			}

			.vlp_box,
			.jszjListBox {
				.mlListItem {
					display: flex;
					background-color: #fff;
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					padding: 0 16px;
					padding-right: 30px;
					color: #000;

					.mlListItem_left {
						width: 200px;
						padding-right: 20px;
						line-height: 60px;

						p {
							span {
								padding-right: 10px;
							}

							.bookName {
								span {
									padding-right: 0px;
								}
							}

							img {
								vertical-align: middle;
								width: 25px;
							}
						}

						.paddBottom {
							padding-bottom: 60px;
						}
					}

					.mlListItem_middle {
						flex: 1;
						line-height: 60px;

						p:first-child {
							// max-width: 240px;
							// overflow: hidden;
							// text-overflow: ellipsis;
							// white-space: nowrap;

						}
					}

					.mlListItem_right {
						width: 100px;
						line-height: 60px;
						padding-top: 60px;
						text-align: right;
					}
				}

				.active {
					color: #9f9f9f;
				}
			}

			.ml_body {
				.jbm {
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					color: #000;
					font-weight: normal;
				}

				font-size: 26px;

				/*px*/
				.mlListItem {
					display: flex;
					background-color: #fff;
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					padding: 0 16px;
					padding-right: 30px;
					color: #000;
					
					&.active {
						color: #fa7298;
						background-color: #fdf2f6;
					}

					.mlListItem_left {
						width: 260px;
						padding-right: 20px;
						line-height: 60px;

						p {
							font-size: 30px;
							/*px*/
							color: #000;
							position: relative;

							span {
								padding-right: 10px;
							}

							.bookName {
								font-size: 30px;
								/*px*/
								width: 160px;

								span {
									padding-right: 0px;
								}
							}

							img {
								width: 25px;
								position: absolute;
								top: 50%;
								right: 0;
								transform: translateY(-50%);
							}

							img.vip_lock {
								width: 25px;
								position: absolute;
								top: 50%;
								right: 20%;
								transform: translateY(-50%);
							}
						}

						p:last-of-type {
							font-size: 24px;
							/*px*/
							color: #000;
							opacity: 0.7;
						}

						.paddBottom {
							padding-bottom: 60px;
						}

						.bookName {
							position: absolute;
							top: 5px;
							font-size: 30px;
							/*px*/
							width: 100px;
							height: 50px;
							line-height: 50px;
							font-size: 28px;
							/*px*/
							color: #686f70;
							overflow: hidden;
							padding-left: 20px;
							display: inline-block;

							span {
								padding-right: 0px;
							}

							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}

							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								padding: 0;
								height: 50px;
							}
						}
					}

					.mlListItem_middle {
						// width: 170px;
						width: calc(100vw - 15vw - 400px);
						line-height: 60px;

						p:first-child {
							// max-width: 180px;
							// overflow: hidden;
							// text-overflow: ellipsis;
							white-space: nowrap;
							font-size: 30px;
							/*px*/
							color: #000;
						}

						p:last-of-type {
							font-size: 24px;
							/*px*/
							color: #000;
							opacity: 0.7;
							width: 360px;
						}
					}

					.mlListItem_right {
						// flex: 1;
						width: 140px;
						line-height: 60px;
						padding-top: 60px;
						text-align: right;
						font-size: 24px;
						/*px*/
						margin-left: 30px;
						color: #000;
						opacity: 0.7;
					}
				}

				.active {
					color: #9f9f9f;
				}
			}

			.lookall,
			.jbm {
				text-align: center;
				line-height: 80px;
				background-color: #fafafa;
			}

			.bookInfoBtn {
				button {
					position: absolute;
					bottom: 40px;
					left: 25%;
					transform: translateX(-25%);
					width: 70vw;
					border: 0;
					background-color: #FF4081;
					opacity: 0.8;
					color: #fff;
					font-size: 30px;
					/*px*/
					border-radius: 10px;
					height: 60px;
					line-height: 60px;
				}
			}
		}

		.mask {
			flex: 1;
			background-color: rgba(0, 0, 0, .6);
		}
	}

	.mask_ds {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.4);
		z-index: 999;
	}

	// 弹窗
	.tostBoxFather {
		z-index: 1000;
		position: fixed;
		bottom: 0;
		left: 0;
		height: 1100px;
		width: 100vw;
		overflow: hidden;

		.header_img {
			position: absolute;
			top: 4px;
			left: 0;

			img {
				width: 100vw;
			}
		}

		// .dog_img{
		// 	img {
		// 		width: 80%;
		// 		position: absolute;
		// 		top: 30%;
		// 		left: 50%;
		// 		transform: translateX(-50%);
		// 		z-index:100;
		// 	}
		// }
		.tostBoxson {
			position: absolute;
			top: 128px;
			left: 0;
			background-color: #fff;

			// 云锦币
			.yunjinbiBox {
				overflow: hidden;
				padding: 20px 16px;
				padding-bottom: 0;
				height: 540px;
				background: url(../../assets/img/dog.png) no-repeat center;
				background-size: 85%;
				background-position: 99% 100%;

				.yunjinbi {
					width: calc((100vw - 88px) / 3);
					box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .3);
					/*no*/
					border: 1px solid #fa7298;
					/*no*/
					padding: 20px 0px;
					text-align: left;
					margin-right: 20px;
					border-radius: 10px;
					float: left;
					margin-bottom: 20px;
					color: #3d3d3d;
					position: relative;
					height: 120px;

					.yunjinbi_left {
						img {
							width: 100px;
							position: absolute;
							top: 30%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}

					.yunjinbi_right {
						// padding-left: 100px;
						padding-top: 55px;
						text-align: center;
					}
				}

				.yunjinbi.active {
					box-shadow: none;
					background-color: #fff8fa;

					color: #000000;
				}

				.yunjinbi:nth-child(3n) {
					margin-right: 0;
				}
			}

			.selecttost {
				background-color: #fff;
				position: relative;
				height: 80px;
				line-height: 80px;
				margin: 0 16px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				font-size: 30px;

				div {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.userInfoUsername {
						font-weight: normal;
						color: #ff4081;
						overflow: hidden;
						width: 30%;

						/deep/.van-cell {
							padding: 0;

							/deep/.van-field__body {
								input {
									color: #ff4081;
								}
							}
						}

						input {
							height: 76px;
							line-height: 76px;
							outline: none;
							border: 0;
							width: 200px;
						}
					}

					.autherName {
						color: #ff4081;
						padding-right: 100px;
					}

					.seleValue {
						display: inline-block;

						i {
							font-style: normal;
						}

						img {
							padding-left: 10px;
							width: 20px;
						}
					}
				}

				// 下拉框css
				ul.select_item {
					position: absolute;
					top: 75px;
					right: 2%;
					background-color: #fff;
					z-index: 100;
					border-radius: 5px;
					-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);

					/*no*/
					li {
						width: 150px;
						padding: 0 20px;
						line-height: 60px;
						border-bottom: 1px solid #f0f0f0;
						/*no*/

						span {
							font-size: 28px;
							/*px*/
						}

						img {
							// margin-left: 60px;
							width: 20px;
							height: 20px;
						}

						.queryArr {
							// padding-left: 20px;
						}
					}

					.activeQuery {
						color: #ff4081;
						border-bottom: 4px solid #f0f0f0;
						display: flex;
						justify-content: space-between;
						align-items: center;
						/*no*/
					}
				}
			}

			//评论
			.tost_say {
				background-color: transparent;
				padding: 20px 0;
				height: 160px;
				margin: 0 16px;
				overflow: hidden;
				position: relative;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.smileImg {
					position: absolute;
					bottom: 10px;
					right: 16px;

					img {
						width: 40px;
					}
				}

				textarea {
					border: 0;
					height: 100%;
					width: calc(100vw - 32px);
					background-color: transparent;
				}

				textarea::placeholder {
					font-size: 26px;
					/*px*/
					color: #3d3d3d;
				}

				.van-cell {
					padding: 0;
				}
			}

			//提交
			.submitBox {
				background-color: #fff;
				position: relative;
				text-align: center;
				margin-top: 30px;
				margin-bottom: 40px;

				.flower {
					position: absolute;
					top: -60px;
					left: 20%;
					width: 100px;
				}

				button {
					width: 90%;
					border: 0;
					border-radius: 10px;
					line-height: 80px;
					font-size: 32px;
					/*px*/
					background-color: #FF4081;
					color: #fff;
				}
			}
		}
	}
	
	.book-test-mark{
		white-space: pre-wrap;
		white-space: -moz-pre-wrap;
		white-space: -o-pre-wrap;
		word-wrap: break-word;
	}
</style>